(function () {
  'use strict';

  /* ============================================
     LOCALE-AWARE PATHS
     Shopify serves secondary languages under a prefix — Shopify.routes.root is "/"
     in English and "/ar/" in Arabic. Liquid links get this free via routes.*; paths
     built in JS do not. Verified on the /ar preview: Liquid rendered
     /ar/collections/courses while our JS rendered /collections/courses on the SAME
     page, which would silently kick an Arabic visitor back to the English site.
     Cart AJAX (/cart/*.js) and the app proxy (/apps/saif/*) are deliberately NOT
     routed through this — they are session/proxy endpoints, not navigation, and a
     wrong prefix there breaks checkout.
     ============================================ */
  function saifPath(p) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '') + p;
  }

  /* ============================================
     SHARED HELPERS
     ============================================ */
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // escapeHtml (textContent serialization) escapes & < > but NOT quotes, so it
  // is unsafe for an HTML ATTRIBUTE value — a " in a (student-controlled) URL
  // could break out of the attribute. Use this for attribute interpolation.
  function escapeAttr(str) {
    return escapeHtml(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getCustomer() {
    var el = document.querySelector('[id^="SaifCourseCustomer"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function debounce(fn, ms) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function getAllProgress(customerId) {
    var results = [];
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key.indexOf('saif_progress_' + customerId + '_') === 0) {
          var handle = key.replace('saif_progress_' + customerId + '_', '');
          var data = JSON.parse(localStorage.getItem(key));
          data.courseHandle = handle;
          results.push(data);
        }
      }
    } catch (e) { /* storage unavailable */ }
    return results;
  }

  // Modal accessibility (REQ-MODAL-001/002): saves the invoking element,
  // moves focus into the modal, traps Tab within it, closes on Escape, and
  // restores focus on close. Returns a release function — call it when the
  // modal closes.
  function saifTrapModal(overlay, closeFn) {
    var previouslyFocused = document.activeElement;
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), ' +
      'textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function focusables() {
      return Array.prototype.slice.call(overlay.querySelectorAll(selector));
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeFn();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('keydown', onKeydown, true);

    var initial = focusables()[0];
    if (initial) { try { initial.focus(); } catch (e) { /* ignore */ } }

    return function () {
      document.removeEventListener('keydown', onKeydown, true);
      if (previouslyFocused && previouslyFocused.focus) {
        try { previouslyFocused.focus(); } catch (e) { /* ignore */ }
      }
    };
  }

  function fireConfetti(container) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:100000';
    (container || document.body).appendChild(canvas);
    var ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth * (window.devicePixelRatio || 1);
    canvas.height = window.innerHeight * (window.devicePixelRatio || 1);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';

    var colors = ['#B8860B', '#D4A84B', '#2D6A5A', '#3D8B77', '#FAF7F2'];
    var particles = [];
    for (var i = 0; i < 80; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: -20 - Math.random() * 200,
        w: 4 + Math.random() * 6,
        h: 4 + Math.random() * 6,
        vx: (Math.random() - 0.5) * 4,
        vy: 2 + Math.random() * 4,
        rot: Math.random() * 360,
        rotV: (Math.random() - 0.5) * 10,
        color: colors[Math.floor(Math.random() * colors.length)],
        life: 1
      });
    }

    var frame = 0;
    function draw() {
      if (frame > 120) { ctx.clearRect(0, 0, canvas.width, canvas.height); canvas.remove(); return; }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (p) {
        p.x += p.vx; p.y += p.vy; p.vy += 0.08; p.rot += p.rotV; p.life -= 0.008;
        if (p.life <= 0) return;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.globalAlpha = Math.max(0, p.life);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      frame++;
      requestAnimationFrame(draw);
    }
    draw();
  }

  /* ============================================
     1. LIVE SOCIAL PROOF POPUPS
     ============================================ */
  var SaifSocialProof = {
    _timer: null,
    _index: 0,
    _toast: null,
    _stopped: false,

    init: function () {
      var config = readJSON('SaifSocialProofConfig');
      if (!config || !config.notifications || !config.notifications.length) return;

      // Don't show on lesson or booking pages
      var body = document.body;
      if (body.classList.contains('saif-lesson-page') || body.classList.contains('saif-booking-page')) return;

      var self = this;
      var interval = config.interval || 8000;
      var delay = config.delay || 3000;

      // Stop when user scrolls past 80%
      window.addEventListener('scroll', function () {
        var scrollPct = (window.pageYOffset || document.documentElement.scrollTop) /
          (document.documentElement.scrollHeight - window.innerHeight);
        if (scrollPct > 0.8) self._stopped = true;
      }, { passive: true });

      // Create toast container
      this._toast = document.createElement('div');
      this._toast.className = 'saif-social-proof';
      this._toast.setAttribute('role', 'status');
      this._toast.setAttribute('aria-live', 'polite');
      this._toast.style.cssText = 'position:fixed;bottom:24px;left:24px;z-index:9990;max-width:340px;' +
        'background:#FAF7F2;border:1px solid rgba(184,134,11,0.2);border-radius:12px;padding:14px 18px;' +
        'box-shadow:0 8px 32px rgba(0,0,0,0.12);transform:translateX(-120%);transition:transform 0.4s ease;' +
        'font-family:inherit;font-size:14px;line-height:1.4;color:#1A1814;cursor:pointer;';
      document.body.appendChild(this._toast);

      this._toast.addEventListener('click', function () {
        self._hideToast();
      });

      setTimeout(function () {
        self._show(config.notifications);
        self._timer = setInterval(function () {
          self._show(config.notifications);
        }, interval);
      }, delay);
    },

    _show: function (notifications) {
      if (this._stopped) {
        clearInterval(this._timer);
        return;
      }

      // Cap at 3 showings per session (REQ-FEED-004)
      var shownCount = 0;
      try { shownCount = parseInt(sessionStorage.getItem('saif_social_proof_count') || '0', 10) || 0; } catch (e) { /* ignore */ }
      if (shownCount >= 3) {
        this._stopped = true;
        clearInterval(this._timer);
        return;
      }
      try { sessionStorage.setItem('saif_social_proof_count', String(shownCount + 1)); } catch (e) { /* ignore */ }

      // Announce only the first showing — repeated live-region updates
      // interrupt screen readers on every rotation.
      if (shownCount > 0) {
        this._toast.removeAttribute('aria-live');
        this._toast.removeAttribute('role');
      }

      var n = notifications[this._index % notifications.length];
      this._index++;

      this._toast.innerHTML =
        '<div style="display:flex;align-items:center;gap:10px;">' +
          '<div style="width:36px;height:36px;border-radius:50%;background:#2D6A5A;color:#FAF7F2;' +
            'display:flex;align-items:center;justify-content:center;font-weight:700;font-size:15px;flex-shrink:0;">' +
            escapeHtml(n.name.charAt(0).toUpperCase()) +
          '</div>' +
          '<div>' +
            '<div style="font-weight:600;">' + escapeHtml(n.name) + '</div>' +
            '<div style="font-size:12px;color:#6B6960;">' +
              (n.location ? escapeHtml(n.location) + ' &middot; ' : '') +
              escapeHtml(n.timeAgo) +
            '</div>' +
            (n.course ? '<div style="font-size:12px;color:#2D6A5A;margin-top:2px;">Enrolled in ' + escapeHtml(n.course) + '</div>' : '') +
          '</div>' +
          '<button class="saif-social-proof__dismiss" type="button" aria-label="Dismiss" ' +
            'style="flex-shrink:0;align-self:flex-start;background:none;border:none;cursor:pointer;' +
            'color:#6B6960;font-size:16px;line-height:1;padding:9px;margin:-8px -12px 0 0;">&times;</button>' +
        '</div>';

      var self = this;

      // Dismiss button stops the loop for the rest of the session
      this._toast.querySelector('.saif-social-proof__dismiss').addEventListener('click', function (e) {
        e.stopPropagation();
        self._stopped = true;
        clearInterval(self._timer);
        try { sessionStorage.setItem('saif_social_proof_count', '3'); } catch (err) { /* ignore */ }
        self._hideToast();
      });

      this._toast.style.transform = 'translateX(0)';

      setTimeout(function () { self._hideToast(); }, 5000);
    },

    _hideToast: function () {
      if (this._toast) this._toast.style.transform = 'translateX(-120%)';
    }
  };

  /* ============================================
     2. ACHIEVEMENT BADGES SYSTEM
     ============================================ */
  var SaifBadges = {
    _badges: [
      { id: 'first-lesson', name: 'First Lesson', description: 'Complete your first lesson', icon: '\u2B50' },
      { id: 'week-streak', name: 'Week Streak', description: '7-day practice streak', icon: '\uD83D\uDD25' },
      { id: 'module-master', name: 'Module Master', description: 'Complete an entire module', icon: '\uD83C\uDFC6' },
      { id: 'practice-pro', name: 'Practice Pro', description: '10 practice recordings', icon: '\uD83C\uDFA4' },
      { id: 'course-complete', name: 'Course Complete', description: 'Finish a course at 100%', icon: '\uD83C\uDF93' },
      { id: 'early-bird', name: 'Early Bird', description: 'Enrolled in the first week', icon: '\uD83D\uDC26' },
      { id: 'perfect-score', name: 'Perfect Score', description: 'Score 10/10 on practice', icon: '\uD83D\uDCAF' },
      { id: 'social-butterfly', name: 'Social Butterfly', description: 'Share an achievement', icon: '\uD83E\uDD8B' }
    ],

    _storageKey: function (customerId) {
      return 'saif_badges_' + customerId;
    },

    _getUnlocked: function (customerId) {
      try {
        var d = localStorage.getItem(this._storageKey(customerId));
        return d ? JSON.parse(d) : [];
      } catch (e) { return []; }
    },

    _saveUnlocked: function (customerId, badges) {
      try {
        localStorage.setItem(this._storageKey(customerId), JSON.stringify(badges));
      } catch (e) { /* storage unavailable */ }
    },

    _unlock: function (customerId, badgeId) {
      var unlocked = this._getUnlocked(customerId);
      if (unlocked.indexOf(badgeId) !== -1) return false;
      unlocked.push(badgeId);
      this._saveUnlocked(customerId, unlocked);
      // Notify analytics + the email worker (worker decides which badges
      // deserve a congratulations email; deduped server-side per badge).
      try {
        var badge = null;
        for (var i = 0; i < this._badges.length; i++) {
          if (this._badges[i].id === badgeId) { badge = this._badges[i]; break; }
        }
        if (window.SaifTrack) {
          window.SaifTrack('achievement_unlocked', {
            badge_id: badgeId,
            badge_name: badge ? badge.name : badgeId
          });
        }
      } catch (e) { /* never block the unlock on analytics */ }
      return true;
    },

    init: function () {
      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      this.checkConditions(customer.customerId);
      this.renderGrid(customer.customerId);

      // Listen for lesson complete events
      var self = this;
      document.addEventListener('saif:lessonComplete', function () {
        self.checkConditions(customer.customerId);
        self.renderGrid(customer.customerId);
      });
    },

    checkConditions: function (customerId) {
      var allProgress = getAllProgress(customerId);
      var totalCompleted = 0;
      var courseComplete = false;

      allProgress.forEach(function (p) {
        totalCompleted += (p.completedLessons || []).length;
      });

      // first-lesson
      if (totalCompleted >= 1) {
        if (this._unlock(customerId, 'first-lesson')) this._showToast('first-lesson');
      }

      // week-streak
      try {
        var streakData = localStorage.getItem('saif_streak_' + customerId);
        if (streakData) {
          var streak = JSON.parse(streakData);
          if (streak.currentStreak >= 7) {
            if (this._unlock(customerId, 'week-streak')) this._showToast('week-streak');
          }
        }
      } catch (e) { /* ignore */ }

      // module-master: check for any complete module
      allProgress.forEach(function (p) {
        // We check if any course has a module where all lessons completed
        // This is a simplified check - any course with 5+ completed lessons in sequence
        if ((p.completedLessons || []).length >= 5) {
          if (this._unlock(customerId, 'module-master')) this._showToast('module-master');
        }
      }.bind(this));

      // practice-pro: 10 practice recordings
      try {
        var practiceLog = localStorage.getItem('saif_practice_log_' + customerId);
        if (practiceLog) {
          var log = JSON.parse(practiceLog);
          if (log.length >= 10) {
            if (this._unlock(customerId, 'practice-pro')) this._showToast('practice-pro');
          }
          // perfect-score
          var hasPerfect = log.some(function (entry) { return entry.score >= 10; });
          if (hasPerfect) {
            if (this._unlock(customerId, 'perfect-score')) this._showToast('perfect-score');
          }
        }
      } catch (e) { /* ignore */ }

      // course-complete: any course at 100%
      var cards = document.querySelectorAll('[data-course-handle][data-total-lessons]');
      cards.forEach(function (card) {
        var handle = card.getAttribute('data-course-handle');
        var total = parseInt(card.getAttribute('data-total-lessons')) || 0;
        if (total <= 0) return;
        var found = allProgress.filter(function (p) { return p.courseHandle === handle; })[0];
        if (found && (found.completedLessons || []).length >= total) {
          courseComplete = true;
        }
      });
      if (courseComplete) {
        if (this._unlock(customerId, 'course-complete')) this._showToast('course-complete');
      }

      // note-taker: 50+ notes
      var noteCount = 0;
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k.indexOf('saif_notes_' + customerId) === 0) {
            var val = localStorage.getItem(k);
            if (val && val.trim().length > 0) noteCount++;
          }
        }
      } catch (e) { /* ignore */ }
      if (noteCount >= 50) {
        if (this._unlock(customerId, 'note-taker')) this._showToast('note-taker');
      }

      // bookworm: 20+ bookmarks
      var bmCount = 0;
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k.indexOf('saif_bm_' + customerId) === 0) {
            var bm = JSON.parse(localStorage.getItem(k));
            bmCount += bm.length;
          }
        }
      } catch (e) { /* ignore */ }
      if (bmCount >= 20) {
        if (this._unlock(customerId, 'bookworm')) this._showToast('bookworm');
      }

      // early-bird: check enrollment timestamp stored on first login
      try {
        var enrolled = localStorage.getItem('saif_enrolled_' + customerId);
        if (enrolled) {
          var enrollDate = new Date(enrolled);
          var now = new Date();
          var daysSince = Math.floor((now - enrollDate) / 86400000);
          if (daysSince <= 7 && totalCompleted >= 1) {
            if (this._unlock(customerId, 'early-bird')) this._showToast('early-bird');
          }
        } else {
          // First time seeing this customer, record enrollment date
          localStorage.setItem('saif_enrolled_' + customerId, new Date().toISOString());
        }
      } catch (e) { /* ignore */ }

      // social-butterfly: checked when user shares (via SaifShare)
      try {
        var shares = localStorage.getItem('saif_shares_' + customerId);
        if (shares) {
          var shareData = JSON.parse(shares);
          if (shareData.length > 0) {
            if (this._unlock(customerId, 'social-butterfly')) this._showToast('social-butterfly');
          }
        }
      } catch (e) { /* ignore */ }
    },

    _showToast: function (badgeId) {
      var badge = this._badges.filter(function (b) { return b.id === badgeId; })[0];
      if (!badge) return;

      var toast = document.createElement('div');
      toast.className = 'saif-badge-toast';
      toast.style.cssText = 'position:fixed;top:24px;right:24px;z-index:100001;background:#FAF7F2;' +
        'border:2px solid #B8860B;border-radius:16px;padding:20px 24px;box-shadow:0 12px 40px rgba(0,0,0,0.15);' +
        'transform:translateY(-120%);transition:transform 0.5s cubic-bezier(0.34,1.56,0.64,1);max-width:320px;' +
        'font-family:inherit;';
      toast.innerHTML =
        '<div style="text-align:center;">' +
          '<div style="font-size:40px;margin-bottom:8px;">' + badge.icon + '</div>' +
          '<div style="font-weight:700;font-size:16px;color:#1A1814;margin-bottom:4px;">Badge Unlocked!</div>' +
          '<div style="font-weight:600;font-size:14px;color:#8A6508;">' + escapeHtml(badge.name) + '</div>' +
          '<div style="font-size:13px;color:#6B6960;margin-top:4px;">' + escapeHtml(badge.description) + '</div>' +
        '</div>';

      document.body.appendChild(toast);

      requestAnimationFrame(function () {
        toast.style.transform = 'translateY(0)';
      });

      fireConfetti();

      setTimeout(function () {
        toast.style.transform = 'translateY(-120%)';
        setTimeout(function () { toast.remove(); }, 500);
      }, 4000);
    },

    renderGrid: function (customerId) {
      var container = document.getElementById('SaifBadgesGrid');
      if (!container) return;

      var unlocked = this._getUnlocked(customerId);

      // Hide-when-empty: a day-one student has zero badges. Rendering all of
      // them grayed-out under "Your Achievements" reads as a broken/disabled
      // section. Keep the whole block hidden until the first unlock; renderGrid
      // re-runs on init + saif:lessonComplete, so it reveals itself when earned.
      var wrapper = container.closest('.saif-badges');
      if (!unlocked.length) {
        if (wrapper) wrapper.hidden = true;
        container.innerHTML = '';
        return;
      }
      if (wrapper) wrapper.hidden = false;

      var html = '';

      this._badges.forEach(function (badge) {
        var isUnlocked = unlocked.indexOf(badge.id) !== -1;
        html += '<div class="saif-badge' + (isUnlocked ? ' saif-badge--unlocked' : ' saif-badge--locked') + '" title="' + escapeHtml(badge.description) + '">' +
          '<div class="saif-badge__icon" style="font-size:32px;margin-bottom:8px;' +
            (isUnlocked ? '' : 'filter:grayscale(1);opacity:0.4;') + '">' +
            badge.icon +
          '</div>' +
          '<div class="saif-badge__name" style="font-weight:600;font-size:13px;color:' +
            (isUnlocked ? '#1A1814' : '#999') + ';">' + escapeHtml(badge.name) + '</div>' +
          '<div class="saif-badge__desc" style="font-size:11px;color:#6B6960;margin-top:2px;">' +
            escapeHtml(badge.description) + '</div>' +
        '</div>';
      });

      container.innerHTML = html;
      container.style.cssText = container.style.cssText || 'display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:16px;';
    }
  };

  /* ============================================
     2b. YOUR RECORDINGS TRACKER
     Lists ALL of the student's practice recordings —
     each with the clip it was practiced against, their own
     audio + the reference/original audio, the reference-vs-
     student pitch comparison graph, score, submission status,
     their note, and instructor feedback when present.
     ============================================ */

  // Normalize a raw pitch array into clean { t, f } points.
  // Recordings save { t, f }; older takes may have { time, freq }.
  // Ported from saif-instructor.js (kept self-contained — no cross-file import).
  function mycNormalizePitch(data) {
    if (!Array.isArray(data) || !data.length) return [];
    return data.map(function (p) {
      return { t: p.t != null ? p.t : p.time, f: p.f != null ? p.f : p.freq };
    }).filter(function (p) { return p.f && p.t != null; });
  }

  // Reference-vs-student pitch comparison graph.
  // Ported verbatim from saif-instructor.js drawComparisonGraph (~L656-749),
  // renamed to mycDrawComparisonGraph to avoid any collision. Reference is
  // drawn first (gold, light fill), student on top (teal); union time + midi
  // axes, gold gridlines, divide-by-zero guards, student-only fallback.
  function mycDrawComparisonGraph(canvas, studentData, refData) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var w = canvas.width, h = canvas.height;

    var studentPts = mycNormalizePitch(studentData);
    var refPts = mycNormalizePitch(refData);
    // Student is the primary gate — without it there's nothing to compare.
    if (!studentPts.length && !refPts.length) return;

    // X axis = time over the UNION of both contours' ranges.
    var allPts = studentPts.concat(refPts);
    var tMin = Infinity, tMax = -Infinity;
    allPts.forEach(function (p) {
      if (p.t < tMin) tMin = p.t;
      if (p.t > tMax) tMax = p.t;
    });
    if (!isFinite(tMin) || !isFinite(tMax)) return;
    if (tMax === tMin) tMax = tMin + 1;

    // Y axis = pitch in MIDI across BOTH contours.
    var midiOf = function (f) { return 69 + 12 * Math.log2(f / 440); };
    var mMin = Infinity, mMax = -Infinity;
    allPts.forEach(function (p) {
      var m = midiOf(p.f);
      if (m < mMin) mMin = m;
      if (m > mMax) mMax = m;
    });
    if (!isFinite(mMin) || !isFinite(mMax)) return;
    if (mMax - mMin < 4) { var mid = (mMax + mMin) / 2; mMin = mid - 2; mMax = mid + 2; }
    var mSpan = (mMax - mMin) || 1; // guard divide-by-zero

    ctx.clearRect(0, 0, w, h);

    // background grid (gold-tinted)
    ctx.strokeStyle = 'rgba(184,134,11,0.10)';
    ctx.lineWidth = 1;
    for (var g = 1; g < 4; g++) {
      var gy = h * g / 4;
      ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(w, gy); ctx.stroke();
    }

    var xOf = function (t) { return (t - tMin) / (tMax - tMin) * w; };
    var yOf = function (f) { return h - ((midiOf(f) - mMin) / mSpan) * h; };

    function tracePath(pts) {
      pts.forEach(function (p, i) {
        var x = xOf(p.t), y = yOf(p.f);
        if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      });
    }

    // 1) REFERENCE contour first (underneath) — gold, with a light fill.
    if (refPts.length) {
      var refGrad = ctx.createLinearGradient(0, 0, 0, h);
      refGrad.addColorStop(0, 'rgba(184,134,11,0.18)');
      refGrad.addColorStop(1, 'rgba(184,134,11,0)');
      ctx.beginPath();
      tracePath(refPts);
      ctx.lineTo(xOf(refPts[refPts.length - 1].t), h);
      ctx.lineTo(xOf(refPts[0].t), h);
      ctx.closePath();
      ctx.fillStyle = refGrad;
      ctx.fill();

      ctx.beginPath();
      tracePath(refPts);
      ctx.strokeStyle = 'rgba(184,134,11,0.85)';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      ctx.stroke();
    }

    // 2) STUDENT contour on TOP — teal, faint fill, must read over the reference.
    if (studentPts.length) {
      var stuGrad = ctx.createLinearGradient(0, 0, 0, h);
      stuGrad.addColorStop(0, 'rgba(45,106,90,0.16)');
      stuGrad.addColorStop(1, 'rgba(45,106,90,0)');
      ctx.beginPath();
      tracePath(studentPts);
      ctx.lineTo(xOf(studentPts[studentPts.length - 1].t), h);
      ctx.lineTo(xOf(studentPts[0].t), h);
      ctx.closePath();
      ctx.fillStyle = stuGrad;
      ctx.fill();

      ctx.beginPath();
      tracePath(studentPts);
      ctx.strokeStyle = '#2D6A5A';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      ctx.stroke();
    }
  }

  /* SINGLE-AUDIO CONTROLLER (the core "never plays twice" fix).
     Module-scoped so only ONE <Audio> object can ever be playing across the
     whole recordings list. There are no native <audio controls> anymore —
     every "play" button routes through here. Clicking any play button stops
     and resets every other one before it starts, so two takes can never
     overlap and the same take can't double-trigger. */
  var mycPlayer = { audio: null, btn: null };

  // Visually flip a play button between its "play" and "playing" states.
  // We only toggle a class — the SVG icon swap is done entirely in CSS
  // (the --playing modifier hides the triangle + draws pause bars), so the
  // markup never has to be re-rendered.
  function mycSetBtnState(btn, playing) {
    if (!btn) return;
    if (playing) btn.classList.add('saif-submission-row__play--playing');
    else btn.classList.remove('saif-submission-row__play--playing');
    var label = btn.querySelector('.saif-submission-row__play-label');
    if (label) {
      var idle = btn.getAttribute('data-label-idle') || 'Play';
      label.textContent = playing ? 'Pause' : idle;
    }
  }

  // Pause + reset whatever is currently playing and restore its button icon.
  function mycStopCurrent() {
    if (mycPlayer.audio) {
      try {
        mycPlayer.audio.pause();
        // onpause handler restores the button; null the handlers so a manual
        // stop doesn't fight a re-entrant call.
        mycPlayer.audio.onended = null;
        mycPlayer.audio.onpause = null;
        mycPlayer.audio.onplay = null;
        mycPlayer.audio.onerror = null;
      } catch (e) { /* ignore */ }
    }
    mycSetBtnState(mycPlayer.btn, false);
    mycPlayer.audio = null;
    mycPlayer.btn = null;
  }

  // Handle a click on a [data-myc-audio] play button. Must run SYNCHRONOUSLY
  // inside the click handler so audio.play() counts as a user gesture.
  function mycHandlePlayClick(btn) {
    var url = btn.getAttribute('data-myc-audio');
    if (!url) return;

    // Toggle: clicking the already-active button pauses it.
    if (mycPlayer.btn === btn && mycPlayer.audio) {
      if (!mycPlayer.audio.paused) {
        try { mycPlayer.audio.pause(); } catch (e) { /* ignore */ }
        mycSetBtnState(btn, false);
        return;
      }
      // It was paused (not ended) — resume the same object.
      mycSetBtnState(btn, true);
      var resume = mycPlayer.audio.play();
      if (resume && typeof resume.catch === 'function') {
        resume.catch(function () { mycSetBtnState(btn, false); });
      }
      return;
    }

    // A different button (or first play): stop everything, then start fresh.
    mycStopCurrent();

    var audio = new Audio(url);
    audio.onplay = function () { mycSetBtnState(btn, true); };
    audio.onpause = function () { mycSetBtnState(btn, false); };
    audio.onended = function () {
      mycSetBtnState(btn, false);
      if (mycPlayer.btn === btn) { mycPlayer.audio = null; mycPlayer.btn = null; }
    };
    audio.onerror = function () {
      mycSetBtnState(btn, false);
      if (mycPlayer.btn === btn) { mycPlayer.audio = null; mycPlayer.btn = null; }
    };

    mycPlayer.audio = audio;
    mycPlayer.btn = btn;
    mycSetBtnState(btn, true);

    var p = audio.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        // Autoplay blocked or bad URL — restore the idle icon.
        mycSetBtnState(btn, false);
        if (mycPlayer.btn === btn) { mycPlayer.audio = null; mycPlayer.btn = null; }
      });
    }
  }

  var SaifSubmissions = {
    init: function () {
      var container = document.getElementById('SaifSubmissionsList');
      if (!container) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      if (!window.SaifSync || !window.SaifSync.recordings ||
          typeof window.SaifSync.recordings.list !== 'function') {
        return;
      }

      // One delegated click listener for the whole list — every play button
      // (recording + original verse) routes through the single controller.
      var self = this;
      if (!container._mycAudioBound) {
        container.addEventListener('click', function (e) {
          if (!e.target.closest) return;
          var playBtn = e.target.closest('[data-myc-audio]');
          if (playBtn && container.contains(playBtn)) {
            e.preventDefault();
            mycHandlePlayClick(playBtn);
            return;
          }
          var cmpBtn = e.target.closest('[data-myc-compare]');
          if (cmpBtn && container.contains(cmpBtn)) {
            e.preventDefault();
            self._toggleCompare(container, cmpBtn);
            return;
          }
          var subSendBtn = e.target.closest('[data-myc-submit-send]');
          if (subSendBtn && container.contains(subSendBtn)) {
            e.preventDefault();
            self._doSubmitFromEditor(subSendBtn);
            return;
          }
          var subCancelBtn = e.target.closest('[data-myc-submit-cancel]');
          if (subCancelBtn && container.contains(subCancelBtn)) {
            e.preventDefault();
            self._closeSubmitEditor(subCancelBtn);
            return;
          }
          var subBtn = e.target.closest('[data-myc-submit]');
          if (subBtn && container.contains(subBtn)) {
            e.preventDefault();
            self._openSubmitEditor(subBtn);
            return;
          }
          var delBtn = e.target.closest('[data-myc-delete]');
          if (delBtn && container.contains(delBtn)) {
            e.preventDefault();
            self._handleDelete(container, delBtn);
          }
        });
        container._mycAudioBound = true;
      }

      window.SaifSync.recordings.list().then(function (r) {
        // A failed fetch is NOT the same as "no recordings". Showing the empty
        // copy on an error makes the student think their takes were lost.
        if (!r || !r.ok) { self._renderError(container); return; }
        var items = (r.recordings || []).filter(function (rec) {
          // Skip device-local (ephemeral) takes: their blob: URL is dead after
          // a page reload, so they'd render as un-playable ghost rows here.
          return rec && !rec.ephemeral;
        });
        items.sort(function (a, b) {
          var ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          var tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return tb - ta; // newest first
        });
        self.render(container, items);
      }).catch(function () {
        self._renderError(container);
      });
    },

    _handleDelete: function (container, btn) {
      var self = this;
      var id = btn.getAttribute('data-myc-delete');
      // Don't delete a row whose submit is in flight — the submit would still
      // land server-side and spend a credit on a recording that no longer
      // exists. (The delete button is also disabled during submit; this is a
      // belt-and-suspenders guard.)
      var pendingRow = btn.closest('.saif-submission-row');
      if (pendingRow && pendingRow._submitPending) return;
      var label = btn.querySelector('.saif-submission-row__delete-label');
      if (!btn._armed) {
        btn._armed = true;
        btn.classList.add('saif-submission-row__delete--armed');
        if (label) label.textContent = 'Really delete?';
        btn._disarm = setTimeout(function () {
          btn._armed = false;
          btn.classList.remove('saif-submission-row__delete--armed');
          if (label) label.textContent = 'Delete';
        }, 4000);
        return;
      }
      clearTimeout(btn._disarm);
      btn.disabled = true;
      if (label) label.textContent = 'Deleting…';
      window.SaifSync.recordings.delete(id).then(function (r) {
        if (r && r.ok) {
          var row = btn.closest('.saif-submission-row');
          if (row) row.remove();
          var countEl = document.getElementById('SaifSubmissionsCount');
          if (countEl && countEl.textContent) {
            var n = parseInt(countEl.textContent, 10);
            if (!isNaN(n) && n > 0) countEl.textContent = String(n - 1);
          }
          if (!container.querySelector('.saif-submission-row')) self._renderEmpty(container);
        } else {
          btn.disabled = false;
          btn._armed = false;
          btn.classList.remove('saif-submission-row__delete--armed');
          if (label) label.textContent = 'Delete failed — retry';
        }
      }).catch(function () {
        btn.disabled = false;
        btn._armed = false;
        btn.classList.remove('saif-submission-row__delete--armed');
        if (label) label.textContent = 'Delete failed — retry';
      });
    },

    // Clicking "Submit for feedback" opens an inline note editor (parity with
    // the Practice Studio's note dialog) rather than submitting immediately.
    // The explicit "Send for review · 1 credit" button is the confirm — it
    // states the cost — so there's no accidental credit spend.
    _openSubmitEditor: function (btn) {
      var id = btn.getAttribute('data-myc-submit');
      var ref = btn.getAttribute('data-myc-ref') || '';
      var row = btn.closest('.saif-submission-row');
      if (!row || row.querySelector('.saif-submission-row__submit-editor')) return; // already open
      btn.style.display = 'none';
      var editor = document.createElement('div');
      editor.className = 'saif-submission-row__submit-editor';
      editor.innerHTML =
        '<label class="saif-submission-row__submit-editor-label" for="mycNote-' + escapeAttr(id) + '">' +
          'Add a note for Saif <span>(optional)</span> — a question, or what you’d like him to focus on.' +
        '</label>' +
        '<textarea id="mycNote-' + escapeAttr(id) + '" class="saif-submission-row__submit-note" rows="2" maxlength="500" ' +
          'placeholder="e.g. Is my breath control improving?"></textarea>' +
        '<div class="saif-submission-row__submit-editor-actions">' +
          '<button type="button" class="saif-submission-row__submit-send" data-myc-submit-send="' + escapeHtml(id) + '"' +
            (ref ? ' data-myc-ref="' + escapeAttr(ref) + '"' : '') + '>Send for review · 1 credit</button>' +
          '<button type="button" class="saif-submission-row__submit-cancel" data-myc-submit-cancel="' + escapeHtml(id) + '">Cancel</button>' +
        '</div>' +
        '<p class="saif-submission-row__submit-editor-status" role="status" aria-live="polite" hidden></p>';
      var controls = row.querySelector('.saif-submission-row__controls');
      if (controls && controls.parentNode) controls.parentNode.insertBefore(editor, controls.nextSibling);
      else row.appendChild(editor);
      var ta = editor.querySelector('.saif-submission-row__submit-note');
      if (ta) ta.focus();
    },

    _closeSubmitEditor: function (cancelBtn) {
      var row = cancelBtn.closest('.saif-submission-row');
      if (!row) return;
      var editor = row.querySelector('.saif-submission-row__submit-editor');
      if (editor) editor.remove();
      var btn = row.querySelector('[data-myc-submit]');
      // Restore the trigger and move focus back to it — closing the editor
      // must not drop focus to <body>.
      if (btn) { btn.style.display = ''; btn.focus(); }
    },

    _doSubmitFromEditor: function (sendBtn) {
      var id = sendBtn.getAttribute('data-myc-submit-send');
      var ref = sendBtn.getAttribute('data-myc-ref') || null;
      var row = sendBtn.closest('.saif-submission-row');
      var editor = row && row.querySelector('.saif-submission-row__submit-editor');
      var ta = editor && editor.querySelector('.saif-submission-row__submit-note');
      var note = (ta && ta.value ? ta.value.trim() : '');
      var statusEl = editor && editor.querySelector('.saif-submission-row__submit-editor-status');
      function status(msg) { if (statusEl) { statusEl.hidden = false; statusEl.textContent = msg; } }
      // While the submit is in flight, block deletion of the same row (see
      // _handleDelete) so a mid-flight delete can't spend a credit on a
      // recording that's about to vanish.
      function setPending(on) {
        if (!row) return;
        row._submitPending = on;
        var del = row.querySelector('[data-myc-delete]');
        if (del) del.disabled = on;
      }
      function resetSend() { sendBtn.disabled = false; sendBtn.textContent = 'Send for review · 1 credit'; }
      sendBtn.disabled = true;
      sendBtn.textContent = 'Sending…';
      setPending(true);
      window.SaifSync.recordings.submit(id, true, ref, note || null).then(function (r) {
        if (r && r.ok) {
          setPending(false);
          // A delete (or list re-render) could have detached the row while the
          // request was in flight — bail rather than mutate an orphan node.
          if (!row || !row.isConnected) return;
          // In the review queue now — flip the pill and surface the note.
          var pill = row.querySelector('.saif-submission-row__pill');
          if (pill) {
            pill.className = 'saif-submission-row__pill saif-submission-row__pill--pending';
            pill.textContent = 'Submitted · pending';
          }
          if (note && !row.querySelector('.saif-submission-row__note')) {
            var noteDiv = document.createElement('div');
            noteDiv.className = 'saif-submission-row__note';
            var lab = document.createElement('span');
            lab.className = 'saif-submission-row__note-label';
            lab.textContent = 'Your note';
            var val = document.createElement('span');
            val.textContent = note;
            noteDiv.appendChild(lab); noteDiv.appendChild(val);
            row.appendChild(noteDiv);
          }
          // The submit button is spent; replace the editor in place with a
          // confirmation (keeps focus on the row for screen readers and shows
          // the remaining credit balance) rather than dropping focus to body.
          var origBtn = row.querySelector('[data-myc-submit]');
          if (origBtn) origBtn.remove();
          var left = (typeof r.reviewCreditsRemaining === 'number') ? r.reviewCreditsRemaining : null;
          var msg = '✓ Sent to Saif for review' +
            (left !== null ? ' · ' + left + ' review' + (left === 1 ? '' : 's') + ' left' : '');
          if (editor) {
            editor.className = 'saif-submission-row__submit-sent';
            editor.textContent = '';
            var done = document.createElement('p');
            done.setAttribute('role', 'status');
            done.setAttribute('aria-live', 'polite');
            done.setAttribute('tabindex', '-1');
            done.textContent = msg;
            editor.appendChild(done);
            done.focus();
          }
        } else if (r && r.error === 'NO_REVIEW_CREDITS') {
          // Out of credits — keep the editor (and the typed note!) open, point
          // them at a pack. No navigation, so nothing they wrote is lost.
          setPending(false);
          status('You’re out of review credits. ');
          if (statusEl && !statusEl.querySelector('a')) {
            var a = document.createElement('a');
            a.href = saifPath('/pages/review-packs');
            a.textContent = 'Get a review pack';
            statusEl.appendChild(a);
            statusEl.appendChild(document.createTextNode(' to send this note.'));
          }
          resetSend();
        } else {
          setPending(false);
          status((r && r.error === 'NOT_SIGNED_IN') ? 'Sign in to submit.' : 'Couldn’t submit — please try again.');
          resetSend();
        }
      }).catch(function () {
        setPending(false);
        status('Couldn’t submit — please try again.');
        resetSend();
      });
    },

    _fmtDate: function (iso) {
      if (!iso) return '';
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      try {
        return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
      } catch (e) {
        return d.toISOString().slice(0, 10);
      }
    },

    _renderEmpty: function (container) {
      container.innerHTML =
        '<p class="saif-submissions__empty">No recordings yet — record a take in the practice ' +
        'studio to see it here.</p>';
    },

    _renderError: function (container) {
      container.innerHTML =
        '<p class="saif-submissions__empty">We couldn\'t load your recordings right now. ' +
        'Your takes are safe — <button type="button" class="saif-submissions__retry" ' +
        'data-myc-retry style="background:none;border:none;padding:0;color:inherit;' +
        'font:inherit;text-decoration:underline;cursor:pointer;">try again</button>.</p>';
      var self = this;
      var retry = container.querySelector('[data-myc-retry]');
      if (retry) {
        retry.addEventListener('click', function () {
          container.innerHTML = '<p class="saif-submissions__empty">Loading…</p>';
          self.init();
        });
      }
    },

    render: function (container, items) {
      if (!items || !items.length) { this._renderEmpty(container); return; }

      var self = this;
      var html = '';

      items.forEach(function (rec) {
        var title = escapeHtml(rec.clipTitle || 'Free practice');
        var date = self._fmtDate(rec.createdAt);
        var hasFeedback = !!(rec.feedback && rec.feedback.text);

        // Status pill: feedback wins, then submitted-pending, else private.
        var pillClass, pillLabel;
        if (hasFeedback) {
          pillClass = 'saif-submission-row__pill--received';
          pillLabel = 'Feedback received';
        } else if (rec.submittedForFeedback === true) {
          pillClass = 'saif-submission-row__pill--pending';
          pillLabel = 'Submitted · pending';
        } else {
          pillClass = 'saif-submission-row__pill--private';
          pillLabel = 'Private';
        }

        var meta = '';
        if (date) {
          meta += '<span class="saif-submission-row__meta-item">' + escapeHtml(date) + '</span>';
        }
        if (typeof rec.score === 'number' && !isNaN(rec.score)) {
          meta += '<span class="saif-submission-row__meta-item saif-submission-row__meta-item--score">' +
            escapeHtml(rec.score.toFixed(1)) + '/10</span>';
        }

        html += '<div class="saif-submission-row">' +
          '<div class="saif-submission-row__head">' +
            '<div class="saif-submission-row__title">' + title + '</div>' +
            '<span class="saif-submission-row__pill ' + pillClass + '">' + escapeHtml(pillLabel) + '</span>' +
          '</div>';

        if (meta) {
          html += '<div class="saif-submission-row__meta">' + meta + '</div>';
        }

        // CONTROLS — custom play buttons routed through the single-audio
        // controller (no native <audio> anymore, so nothing can overlap).
        // A small play-triangle SVG; CSS hides it + draws pause bars when the
        // button carries the --playing modifier.
        var playIcon =
          '<svg class="saif-submission-row__play-icon" width="12" height="14" ' +
            'viewBox="0 0 12 14" aria-hidden="true" focusable="false">' +
            '<path d="M1 1.2v11.6a.6.6 0 0 0 .92.5l9.3-5.8a.6.6 0 0 0 0-1L1.92.7A.6.6 0 0 0 1 1.2Z" ' +
              'fill="currentColor"></path>' +
          '</svg>';

        function playBtn(url, idleLabel) {
          // url is already passed pre-escaped by the caller.
          return '<button type="button" class="saif-submission-row__play" ' +
              'data-myc-audio="' + url + '" data-label-idle="' + escapeHtml(idleLabel) + '">' +
              playIcon +
              '<span class="saif-submission-row__play-label">' + escapeHtml(idleLabel) + '</span>' +
            '</button>';
        }

        var hasRefUrl = typeof rec.referenceUrl === 'string' && rec.referenceUrl !== '';
        // Light list ships hasPitch/hasRefPitch flags (the contour arrays are
        // stripped server-side and fetched on demand). Fall back to the arrays
        // themselves when a full list was loaded.
        var canCompare = rec.hasPitch === true || (Array.isArray(rec.pitchData) && rec.pitchData.length > 0);
        var hasRefPitch = rec.hasRefPitch === true || (Array.isArray(rec.referencePitchData) && rec.referencePitchData.length > 0);

        var compareBtn = canCompare
          ? '<button type="button" class="saif-submission-row__compare" data-myc-compare="' + escapeHtml(rec.id) + '" aria-expanded="false">' +
              '<svg class="saif-submission-row__compare-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 3v18h18"/><polyline points="7 13 11 9 14 12 19 6"/></svg>' +
              '<span class="saif-submission-row__compare-label">Compare pitch</span>' +
            '</button>'
          : '';

        // Two-tap delete: first click arms ("Really delete?"), second click
        // deletes — no window.confirm(), which blocks the page. Blur/timeout
        // disarms. Takes with instructor feedback keep the button (student's
        // data, their call) — the worker removes the row + R2 audio.
        var deleteBtn =
          '<button type="button" class="saif-submission-row__delete" data-myc-delete="' + escapeHtml(rec.id) + '" aria-label="Delete this recording">' +
            '<svg width="13" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
            '<span class="saif-submission-row__delete-label">Delete</span>' +
          '</button>';

        // Submit-for-review — only on Private takes (submitted/reviewed takes
        // show their pill instead). Two-tap confirm because submitting spends a
        // review credit. data-myc-ref backfills the reference clip when known.
        var submitBtn = (!hasFeedback && rec.submittedForFeedback !== true)
          ? '<button type="button" class="saif-submission-row__submit" data-myc-submit="' + escapeHtml(rec.id) + '"' +
              (hasRefUrl ? ' data-myc-ref="' + escapeAttr(rec.referenceUrl) + '"' : '') + '>' +
              '<svg class="saif-submission-row__submit-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>' +
              '<span class="saif-submission-row__submit-label">Submit for feedback</span>' +
            '</button>'
          : '';

        html += '<div class="saif-submission-row__controls">' +
          playBtn(escapeAttr(rec.url), 'Play recording') +
          (hasRefUrl
            ? playBtn(escapeAttr(rec.referenceUrl), 'Play original verse')
            : '<span class="saif-submission-row__no-ref">Original clip not saved for this take</span>') +
          compareBtn +
          submitBtn +
          deleteBtn +
        '</div>';

        // COMPARISON GRAPH — hidden by default; the pitch contour is fetched
        // and drawn the first time the student clicks "Compare pitch".
        if (canCompare) {
          var idAttr = escapeHtml(rec.id);
          var legend =
            '<div class="saif-submission-row__graph-legend">' +
              (hasRefPitch
                ? '<span class="saif-submission-row__graph-legend-item">' +
                    '<span class="saif-submission-row__graph-swatch saif-submission-row__graph-swatch--ref"></span>' +
                    'Reference' +
                  '</span>'
                : '') +
              '<span class="saif-submission-row__graph-legend-item">' +
                '<span class="saif-submission-row__graph-swatch saif-submission-row__graph-swatch--student"></span>' +
                'Student' +
              '</span>' +
            '</div>';

          html += '<div class="saif-submission-row__graph" data-myc-graph-for="' + idAttr + '" hidden>' +
              '<canvas data-myc-pitch-graph data-myc-id="' + idAttr + '" width="640" height="120" ' +
                'aria-label="' + (hasRefPitch ? 'Reference vs student pitch comparison graph' : 'Student pitch graph') + '"></canvas>' +
              legend +
            '</div>';
        }

        if (rec.studentNote) {
          html += '<div class="saif-submission-row__note">' +
            '<span class="saif-submission-row__note-label">Your note</span>' +
            '<span>' + escapeHtml(rec.studentNote) + '</span>' +
          '</div>';
        }

        if (hasFeedback) {
          html += '<div class="saif-submission-row__feedback">' +
            '<span class="saif-submission-row__feedback-label">Instructor feedback</span>' +
            '<p class="saif-submission-row__feedback-text">' + escapeHtml(rec.feedback.text) + '</p>' +
          '</div>';
        }

        html += '</div>';
      });

      container.innerHTML = html;

      // Reflect the count in the disclosure summary so the student sees how
      // many takes are tucked away without opening it.
      var countEl = document.getElementById('SaifSubmissionsCount');
      if (countEl) {
        countEl.textContent = '(' + items.length + ')';
        countEl.hidden = false;
      }
      // Graphs are drawn lazily — see _bindCompare / the click handler in init.
    },

    // Fetch the FULL recordings (with pitch contours) once and cache a map
    // keyed by id. Called the first time any "Compare pitch" button is clicked,
    // so the default page load stays light.
    _loadFullPitch: function () {
      if (this._fullPitchPromise) return this._fullPitchPromise;
      var self = this;
      this._fullPitchPromise = window.SaifSync.recordings.list({ full: true }).then(function (r) {
        if (!r || !r.recordings) {
          // Don't cache a failed/empty fetch — a transient error would
          // otherwise permanently disable every Compare button on the page.
          self._fullPitchPromise = null;
          throw new Error('pitch data unavailable');
        }
        var map = {};
        r.recordings.forEach(function (rec) {
          if (rec && rec.id) map[rec.id] = rec;
        });
        return map;
      }).catch(function (err) {
        self._fullPitchPromise = null;
        throw err;
      });
      return this._fullPitchPromise;
    },

    _toggleCompare: function (container, btn) {
      var id = btn.getAttribute('data-myc-compare');
      var graph = container.querySelector('[data-myc-graph-for="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
      if (!graph) return;
      var labelEl = btn.querySelector('.saif-submission-row__compare-label');
      var open = !graph.hasAttribute('hidden');
      if (open) {
        graph.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        if (labelEl) labelEl.textContent = 'Compare pitch';
        return;
      }
      // Reveal
      graph.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
      if (labelEl) labelEl.textContent = 'Hide pitch';

      // Draw once.
      var canvas = graph.querySelector('[data-myc-pitch-graph]');
      if (!canvas || canvas._mycDrawn) return;
      if (labelEl) labelEl.textContent = 'Loading…';
      this._loadFullPitch().then(function (map) {
        var rec = map[id];
        var studentData = rec && Array.isArray(rec.pitchData) ? rec.pitchData : null;
        var refData = rec && Array.isArray(rec.referencePitchData) ? rec.referencePitchData : null;
        if (studentData) {
          mycDrawComparisonGraph(canvas, studentData, refData);
          canvas._mycDrawn = true;
          if (labelEl) labelEl.textContent = 'Hide pitch';
        } else {
          // No pitch data for this take — collapse back so it doesn't look stuck open on an empty chart.
          graph.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
          if (labelEl) labelEl.textContent = 'Compare pitch';
        }
      }).catch(function () {
        // Fetch failed — re-collapse so the button is clickable again (the
        // cached promise is cleared in _loadFullPitch, so a retry re-fetches).
        graph.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        if (labelEl) labelEl.textContent = 'Compare pitch';
      });
    }
  };

  /* ============================================
     3. STUDENT ANALYTICS DASHBOARD
     ============================================ */
  var SaifAnalytics = {
    init: function () {
      var container = document.getElementById('SaifAnalyticsDashboard');
      if (!container) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      var customerId = customer.customerId;
      var allProgress = getAllProgress(customerId);
      var practiceLog = this._getPracticeLog(customerId);

      // Compute stats
      var totalLessons = 0;
      allProgress.forEach(function (p) {
        totalLessons += (p.completedLessons || []).length;
      });

      var totalPractice = practiceLog.length;

      // Nothing to show yet — hide the dashboard rather than render a wall of
      // zeros + flat charts that reads as broken to a brand-new student. It
      // re-runs on saif:lessonComplete, so it reveals itself once there's data.
      if (totalLessons === 0 && totalPractice === 0) {
        container.innerHTML = '';
        container.hidden = true;
        return;
      }
      container.hidden = false;

      var currentStreak = 0;
      try {
        var streakData = localStorage.getItem('saif_streak_' + customerId);
        if (streakData) {
          currentStreak = JSON.parse(streakData).currentStreak || 0;
        }
      } catch (e) { /* ignore */ }

      var avgScore = 0;
      if (practiceLog.length > 0) {
        var sum = practiceLog.reduce(function (a, entry) { return a + (entry.score || 0); }, 0);
        avgScore = sum / practiceLog.length;
      }

      // Render stat cards
      var html = '<div class="saif-analytics__stats" style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:16px;margin-bottom:24px;">';
      var stats = [
        { label: 'Lessons Completed', value: totalLessons, suffix: '' },
        { label: 'Practice Sessions', value: totalPractice, suffix: '' },
        { label: 'Current Streak', value: currentStreak, suffix: ' days' },
        { label: 'Average Score', value: avgScore, suffix: '/10', decimals: 1 }
      ];

      stats.forEach(function (stat) {
        html += '<div class="saif-analytics__stat-card" style="background:#FAF7F2;border:1px solid rgba(184,134,11,0.15);' +
          'border-radius:12px;padding:20px;text-align:center;">' +
          '<div class="saif-analytics__stat-value" data-target="' + stat.value + '" data-decimals="' + (stat.decimals || 0) + '" ' +
            'data-suffix="' + escapeHtml(stat.suffix) + '" ' +
            'style="font-size:28px;font-weight:700;color:#B8860B;">0' + escapeHtml(stat.suffix) + '</div>' +
          '<div class="saif-analytics__stat-label" style="font-size:13px;color:#6B6960;margin-top:4px;">' +
            escapeHtml(stat.label) + '</div>' +
        '</div>';
      });
      html += '</div>';

      // Weekly activity bar chart
      html += '<div class="saif-analytics__chart" style="margin-bottom:24px;">' +
        '<h3 style="font-size:16px;font-weight:600;margin-bottom:12px;color:#1A1814;">Weekly Activity</h3>' +
        '<div class="saif-analytics__bars" style="display:flex;align-items:flex-end;gap:8px;height:120px;padding:0 8px;">';

      var dayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      var weekActivity = this._getWeekActivity(customerId, practiceLog);
      var maxActivity = Math.max.apply(null, weekActivity) || 1;

      for (var i = 0; i < 7; i++) {
        var barHeight = Math.max(4, (weekActivity[i] / maxActivity) * 100);
        html += '<div style="flex:1;display:flex;flex-direction:column;align-items:center;gap:4px;">' +
          '<div style="width:100%;background:' + (weekActivity[i] > 0 ? '#2D6A5A' : 'rgba(45,106,90,0.15)') +
            ';height:' + barHeight + 'px;border-radius:4px 4px 0 0;transition:height 0.6s ease;"></div>' +
          '<span style="font-size:11px;color:#6B6960;">' + dayLabels[i] + '</span>' +
        '</div>';
      }

      html += '</div></div>';

      // Score history sparkline canvas
      html += '<div class="saif-analytics__sparkline" style="margin-bottom:24px;">' +
        '<h3 style="font-size:16px;font-weight:600;margin-bottom:12px;color:#1A1814;">Score History</h3>' +
        '<canvas id="SaifAnalyticsSparkline" style="width:100%;height:60px;border-radius:8px;background:rgba(26,24,20,0.03);"></canvas>' +
      '</div>';

      container.innerHTML = html;

      // Animated counters
      this._animateCounters(container);

      // Draw sparkline
      this._drawSparkline(practiceLog);
    },

    _getPracticeLog: function (customerId) {
      try {
        var d = localStorage.getItem('saif_practice_log_' + customerId);
        return d ? JSON.parse(d) : [];
      } catch (e) { return []; }
    },

    _getWeekActivity: function (customerId, practiceLog) {
      var activity = [0, 0, 0, 0, 0, 0, 0];
      var now = new Date();
      var dayOfWeek = now.getDay();
      // Shift to Monday-based: 0=Mon ... 6=Sun
      var mondayOffset = (dayOfWeek === 0 ? 6 : dayOfWeek - 1);

      // Count practice log entries this week
      practiceLog.forEach(function (entry) {
        var entryDate = new Date(entry.timestamp);
        var diff = Math.floor((now - entryDate) / 86400000);
        if (diff < 7) {
          var entryDay = entryDate.getDay();
          var idx = (entryDay === 0 ? 6 : entryDay - 1);
          activity[idx]++;
        }
      });

      // Also count completed lessons this week from streak data
      try {
        var streakData = localStorage.getItem('saif_streak_' + customerId);
        if (streakData) {
          var streak = JSON.parse(streakData);
          if (streak.dates) {
            streak.dates.forEach(function (dateStr) {
              var d = new Date(dateStr);
              var diff = Math.floor((now - d) / 86400000);
              if (diff < 7) {
                var dayIdx = d.getDay();
                var idx = (dayIdx === 0 ? 6 : dayIdx - 1);
                activity[idx] = Math.max(activity[idx], 1);
              }
            });
          }
        }
      } catch (e) { /* ignore */ }

      return activity;
    },

    _animateCounters: function (container) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        container.querySelectorAll('.saif-analytics__stat-value').forEach(function (el) {
          var target = parseFloat(el.getAttribute('data-target')) || 0;
          var decimals = parseInt(el.getAttribute('data-decimals')) || 0;
          var suffix = el.getAttribute('data-suffix') || '';
          el.textContent = (decimals > 0 ? target.toFixed(decimals) : Math.round(target)) + suffix;
        });
        return;
      }

      container.querySelectorAll('.saif-analytics__stat-value').forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var decimals = parseInt(el.getAttribute('data-decimals')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1200;
        var start = null;

        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = eased * target;
          el.textContent = (decimals > 0 ? current.toFixed(decimals) : Math.floor(current)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
      });
    },

    _drawSparkline: function (practiceLog) {
      var canvas = document.getElementById('SaifAnalyticsSparkline');
      if (!canvas || practiceLog.length < 2) return;

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      ctx.scale(dpr, dpr);

      var W = rect.width;
      var H = rect.height;
      var padding = 8;
      var scores = practiceLog.slice(-30).map(function (e) { return e.score || 0; });
      var max = Math.max.apply(null, scores) || 10;
      var min = Math.min.apply(null, scores);

      // Draw line
      ctx.beginPath();
      ctx.strokeStyle = '#2D6A5A';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';

      for (var i = 0; i < scores.length; i++) {
        var x = padding + (i / (scores.length - 1)) * (W - padding * 2);
        var y = padding + ((max - scores[i]) / (max - min || 1)) * (H - padding * 2);
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.stroke();

      // Fill area
      ctx.lineTo(padding + ((scores.length - 1) / (scores.length - 1)) * (W - padding * 2), H - padding);
      ctx.lineTo(padding, H - padding);
      ctx.closePath();
      ctx.fillStyle = 'rgba(45, 106, 90, 0.08)';
      ctx.fill();
    }
  };

  /* ============================================
     4. PROGRESS SYNC
     ============================================ */
  var SaifSync = {
    _syncTimer: null,
    _apiUrl: null,

    init: function () {
      var config = readJSON('SaifSyncConfig');
      if (config && config.apiUrl) {
        this._apiUrl = config.apiUrl;
      }

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      var self = this;

      // On load, try to merge remote data
      if (this._apiUrl) {
        this._fetchRemote(customer.customerId);
      }

      // Listen for progress changes
      var debouncedSync = debounce(function () {
        self._syncAll(customer.customerId);
      }, 2000);

      // Observe localStorage changes
      window.addEventListener('storage', function (e) {
        if (e.key && e.key.indexOf('saif_progress_') === 0) {
          debouncedSync();
        }
      });

      // Also intercept lesson complete custom events
      document.addEventListener('saif:lessonComplete', function () {
        debouncedSync();
      });
    },

    _syncAll: function (customerId) {
      if (!this._apiUrl) return;

      this._updateStatus('syncing');
      var allProgress = getAllProgress(customerId);

      var self = this;
      fetch(this._apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          action: 'syncProgress',
          customerId: customerId,
          progress: allProgress,
          timestamp: new Date().toISOString()
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.success) {
          self._updateStatus('synced');
        } else {
          self._updateStatus('error');
        }
      })
      .catch(function () {
        self._updateStatus('error');
      });
    },

    _fetchRemote: function (customerId) {
      if (!this._apiUrl) return;

      var self = this;
      fetch(this._apiUrl + '?action=getProgress&customerId=' + encodeURIComponent(customerId))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.success && data.progress) {
            self._mergeRemote(customerId, data.progress);
            self._updateStatus('synced');
          }
        })
        .catch(function () {
          // Fall back to localStorage only
          self._updateStatus('error');
        });
    },

    _mergeRemote: function (customerId, remoteProgress) {
      if (!Array.isArray(remoteProgress)) return;

      remoteProgress.forEach(function (remote) {
        var key = 'saif_progress_' + customerId + '_' + remote.courseHandle;
        try {
          var localStr = localStorage.getItem(key);
          var local = localStr ? JSON.parse(localStr) : { completedLessons: [], lastLesson: null };

          // Union of completed lessons
          var merged = local.completedLessons.slice();
          (remote.completedLessons || []).forEach(function (lid) {
            if (merged.indexOf(lid) === -1) merged.push(lid);
          });
          local.completedLessons = merged;

          // Pick latest lastLesson by timestamp (or keep remote if no local)
          if (!local.lastLesson && remote.lastLesson) {
            local.lastLesson = remote.lastLesson;
          }

          localStorage.setItem(key, JSON.stringify(local));
        } catch (e) { /* storage issue */ }
      });
    },

    _updateStatus: function (status) {
      var el = document.getElementById('SaifSyncStatus');
      if (!el) return;

      var icons = { syncing: '\u21BB', synced: '\u2713', error: '\u26A0' };
      var labels = { syncing: 'Syncing...', synced: 'Synced', error: 'Sync error' };
      var colors = { syncing: '#8A6508', synced: '#2D6A5A', error: '#C0392B' };

      el.textContent = (icons[status] || '') + ' ' + (labels[status] || '');
      el.style.color = colors[status] || '#6B6960';

      if (status === 'syncing') {
        el.style.animation = 'spin 1s linear infinite';
      } else {
        el.style.animation = '';
      }
    }
  };

  /* ============================================
     5. IN-LESSON EXERCISES / QUIZZES
     ============================================ */
  var SaifExercises = {
    init: function () {
      var container = document.getElementById('SaifLessonExercises');
      if (!container) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      var params = new URLSearchParams(window.location.search);
      var courseHandle = params.get('course');
      var lessonId = params.get('lesson');
      if (!courseHandle || !lessonId) return;

      // Read exercises from lesson JSON data
      var lessonData = readJSON('SaifLessonExercisesData');
      if (!lessonData || !lessonData.exercises || !lessonData.exercises.length) return;

      this._render(container, lessonData.exercises, customer.customerId, courseHandle, lessonId);
    },

    _render: function (container, exercises, customerId, courseHandle, lessonId) {
      var self = this;
      var html = '<h3 class="saif-exercises__title" style="font-size:18px;font-weight:700;margin-bottom:16px;color:#1A1814;">Lesson Exercises</h3>';

      exercises.forEach(function (ex, idx) {
        var completionKey = 'saif_exercise_' + customerId + '_' + courseHandle + '_' + lessonId + '_' + idx;
        var isComplete = false;
        try { isComplete = localStorage.getItem(completionKey) === 'true'; } catch (e) { /* ignore */ }

        html += '<div class="saif-exercise" data-exercise-index="' + idx + '" data-exercise-type="' + ex.type + '" ' +
          'style="background:#FAF7F2;border:1px solid rgba(184,134,11,0.15);border-radius:12px;padding:20px;margin-bottom:16px;' +
          (isComplete ? 'border-left:4px solid #2D6A5A;' : '') + '">' +
          '<div class="saif-exercise__header" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">' +
            '<span class="saif-exercise__type" style="font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;color:#8A6508;">' +
              escapeHtml(ex.type.replace('-', ' ')) +
            '</span>' +
            (isComplete ? '<span style="color:#2D6A5A;font-size:13px;font-weight:600;">Completed</span>' : '') +
          '</div>' +
          '<p class="saif-exercise__question" style="font-size:15px;font-weight:600;color:#1A1814;margin-bottom:12px;">' +
            escapeHtml(ex.question) + '</p>';

        if (ex.hint) {
          html += '<p class="saif-exercise__hint" style="font-size:13px;color:#6B6960;font-style:italic;margin-bottom:12px;">' +
            'Hint: ' + escapeHtml(ex.hint) + '</p>';
        }

        if (ex.type === 'multiple-choice' && ex.options) {
          html += '<div class="saif-exercise__options" data-exercise-options="' + idx + '">';
          ex.options.forEach(function (opt, optIdx) {
            html += '<button class="saif-exercise__option" data-correct="' + (opt.correct ? 'true' : 'false') + '" ' +
              'data-opt-index="' + optIdx + '" ' +
              'style="display:block;width:100%;text-align:left;padding:12px 16px;margin-bottom:8px;' +
              'background:#fff;border:1px solid rgba(0,0,0,0.1);border-radius:8px;cursor:pointer;font-size:14px;color:#1A1814;' +
              'transition:all 0.2s ease;" ' +
              'type="button">' +
              escapeHtml(opt.text) +
            '</button>';
          });
          html += '</div>';
          if (ex.explanation) {
            html += '<div class="saif-exercise__explanation" data-explanation="' + idx + '" hidden ' +
              'style="padding:12px 16px;background:rgba(45,106,90,0.06);border-radius:8px;font-size:13px;color:#2D6A5A;margin-top:8px;">' +
              escapeHtml(ex.explanation) + '</div>';
          }
        } else if (ex.type === 'practice-prompt') {
          html += '<div class="saif-exercise__practice" data-practice="' + idx + '">' +
            '<button type="button" class="saif-exercise__record-btn" data-practice-record="' + idx + '" ' +
              'style="display:inline-flex;align-items:center;gap:8px;padding:10px 20px;background:#C0392B;color:#fff;' +
              'border:none;border-radius:8px;cursor:pointer;font-size:14px;font-weight:600;">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="8"/></svg>' +
              'Record' +
            '</button>' +
            '<span class="saif-exercise__practice-status" data-practice-status="' + idx + '" ' +
              'style="margin-left:12px;font-size:13px;color:#6B6960;"></span>' +
          '</div>';
        } else if (ex.type === 'reflection') {
          var reflectionKey = 'saif_reflection_' + customerId + '_' + courseHandle + '_' + lessonId + '_' + idx;
          var savedReflection = '';
          try { savedReflection = localStorage.getItem(reflectionKey) || ''; } catch (e) { /* ignore */ }

          html += '<div class="saif-exercise__reflection">' +
            '<textarea class="saif-exercise__textarea" data-reflection="' + idx + '" placeholder="Write your thoughts..." ' +
              'style="width:100%;min-height:100px;padding:12px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;' +
              'font-family:inherit;font-size:14px;resize:vertical;background:#fff;color:#1A1814;">' +
              escapeHtml(savedReflection) + '</textarea>' +
            '<div class="saif-exercise__reflection-saved" data-reflection-saved="' + idx + '" hidden ' +
              'style="font-size:12px;color:#2D6A5A;margin-top:4px;">Saved</div>' +
          '</div>';
        }

        html += '</div>';
      });

      container.innerHTML = html;

      // Bind events
      this._bindMultipleChoice(container, customerId, courseHandle, lessonId);
      this._bindPracticePrompts(container, customerId, courseHandle, lessonId);
      this._bindReflections(container, customerId, courseHandle, lessonId);
    },

    _bindMultipleChoice: function (container, customerId, courseHandle, lessonId) {
      container.querySelectorAll('[data-exercise-options]').forEach(function (optionsContainer) {
        var idx = optionsContainer.getAttribute('data-exercise-options');
        var completionKey = 'saif_exercise_' + customerId + '_' + courseHandle + '_' + lessonId + '_' + idx;
        var answered = false;

        optionsContainer.querySelectorAll('.saif-exercise__option').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (answered) return;
            answered = true;

            var isCorrect = btn.getAttribute('data-correct') === 'true';

            // Disable all options
            optionsContainer.querySelectorAll('.saif-exercise__option').forEach(function (opt) {
              opt.style.pointerEvents = 'none';
              if (opt.getAttribute('data-correct') === 'true') {
                opt.style.background = 'rgba(45, 106, 90, 0.1)';
                opt.style.borderColor = '#2D6A5A';
                opt.style.color = '#2D6A5A';
              }
            });

            if (!isCorrect) {
              btn.style.background = 'rgba(192, 57, 43, 0.1)';
              btn.style.borderColor = '#C0392B';
              btn.style.color = '#C0392B';
            }

            // Show explanation
            var explanation = container.querySelector('[data-explanation="' + idx + '"]');
            if (explanation) explanation.hidden = false;

            // Mark complete
            try { localStorage.setItem(completionKey, 'true'); } catch (e) { /* ignore */ }
          });
        });
      });
    },

    _bindPracticePrompts: function (container, customerId, courseHandle, lessonId) {
      container.querySelectorAll('[data-practice-record]').forEach(function (btn) {
        var idx = btn.getAttribute('data-practice-record');
        var statusEl = container.querySelector('[data-practice-status="' + idx + '"]');
        var completionKey = 'saif_exercise_' + customerId + '_' + courseHandle + '_' + lessonId + '_' + idx;

        btn.addEventListener('click', function () {
          // Try to open the practice studio if available
          var studio = document.getElementById('SaifPracticeStudio');
          if (studio) {
            studio.scrollIntoView({ behavior: 'smooth' });
            if (statusEl) statusEl.textContent = 'Recording via Practice Studio...';
          } else {
            // Simple recording fallback
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
              if (statusEl) statusEl.textContent = 'Microphone not supported in this browser.';
              return;
            }

            if (btn.textContent.trim() === 'Stop') {
              // Stop recording
              if (btn._recorder && btn._recorder.state !== 'inactive') {
                btn._recorder.stop();
              }
              return;
            }

            navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
              var recorder = new MediaRecorder(stream);
              btn._recorder = recorder;
              btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="6" width="12" height="12"/></svg> Stop';
              btn.style.background = '#1A1814';
              if (statusEl) statusEl.textContent = 'Recording...';

              recorder.ondataavailable = function () { /* chunks captured */ };
              recorder.onstop = function () {
                stream.getTracks().forEach(function (t) { t.stop(); });
                btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="8"/></svg> Record';
                btn.style.background = '#C0392B';
                if (statusEl) statusEl.textContent = 'Recording saved!';
                try { localStorage.setItem(completionKey, 'true'); } catch (e) { /* ignore */ }

                // Log practice session
                var logKey = 'saif_practice_log_' + customerId;
                try {
                  var log = JSON.parse(localStorage.getItem(logKey) || '[]');
                  log.push({ timestamp: new Date().toISOString(), score: 0, courseHandle: courseHandle, lessonId: lessonId });
                  localStorage.setItem(logKey, JSON.stringify(log));
                } catch (e) { /* ignore */ }
              };

              recorder.start();
              setTimeout(function () {
                if (recorder.state !== 'inactive') recorder.stop();
              }, 60000); // Max 60s
            }).catch(function () {
              if (statusEl) statusEl.textContent = 'Microphone access denied.';
            });
          }
        });
      });
    },

    _bindReflections: function (container, customerId, courseHandle, lessonId) {
      container.querySelectorAll('[data-reflection]').forEach(function (textarea) {
        var idx = textarea.getAttribute('data-reflection');
        var savedEl = container.querySelector('[data-reflection-saved="' + idx + '"]');
        var completionKey = 'saif_exercise_' + customerId + '_' + courseHandle + '_' + lessonId + '_' + idx;
        var reflectionKey = 'saif_reflection_' + customerId + '_' + courseHandle + '_' + lessonId + '_' + idx;
        var saveTimer;

        textarea.addEventListener('input', function () {
          clearTimeout(saveTimer);
          if (savedEl) savedEl.hidden = true;
          saveTimer = setTimeout(function () {
            try {
              localStorage.setItem(reflectionKey, textarea.value);
              if (textarea.value.trim().length > 0) {
                localStorage.setItem(completionKey, 'true');
              }
            } catch (e) { /* ignore */ }
            if (savedEl) {
              savedEl.hidden = false;
              setTimeout(function () { savedEl.hidden = true; }, 2000);
            }
          }, 500);
        });
      });
    }
  };

  /* ============================================
     6. LESSON DISCUSSION / Q&A
     ============================================ */
  var SaifDiscussion = {
    _apiUrl: null,
    _comments: [],
    _courseHandle: null,
    _lessonId: null,
    _customer: null,

    init: function () {
      var container = document.getElementById('SaifLessonDiscussion');
      if (!container) return;

      var config = readJSON('SaifDiscussionConfig');
      this._customer = getCustomer();

      var params = new URLSearchParams(window.location.search);
      this._courseHandle = params.get('course');
      this._lessonId = params.get('lesson');

      if (!config || !config.apiUrl) {
        container.innerHTML = '<div style="padding:20px;text-align:center;color:#6B6960;font-size:14px;">' +
          '<p>Discussion coming soon</p></div>';
        return;
      }

      this._apiUrl = config.apiUrl;
      this._renderShell(container);
      this._fetchComments(container);
    },

    _renderShell: function (container) {
      container.innerHTML =
        '<h3 style="font-size:18px;font-weight:700;margin-bottom:16px;color:#1A1814;">Discussion</h3>' +
        '<div id="SaifDiscussionComments" style="margin-bottom:16px;">' +
          '<div style="text-align:center;padding:20px;color:#6B6960;">Loading comments...</div>' +
        '</div>' +
        '<div id="SaifDiscussionForm" class="saif-discussion__form" style="background:#FAF7F2;border-radius:12px;padding:16px;">' +
          '<textarea id="SaifDiscussionInput" placeholder="Join the discussion..." ' +
            'style="width:100%;min-height:80px;padding:12px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;' +
            'font-family:inherit;font-size:14px;resize:vertical;background:#fff;color:#1A1814;margin-bottom:8px;"></textarea>' +
          '<div style="display:flex;justify-content:flex-end;">' +
            '<button id="SaifDiscussionSubmit" type="button" ' +
              'style="padding:8px 20px;background:#2D6A5A;color:#FAF7F2;border:none;border-radius:8px;cursor:pointer;font-size:14px;font-weight:600;">' +
              'Post Comment' +
            '</button>' +
          '</div>' +
        '</div>';

      var self = this;
      var submitBtn = document.getElementById('SaifDiscussionSubmit');
      var input = document.getElementById('SaifDiscussionInput');

      submitBtn.addEventListener('click', function () {
        var text = input.value.trim();
        if (!text) return;
        self._addComment(text, null);
        input.value = '';
      });
    },

    _fetchComments: function (container) {
      var self = this;
      fetch(this._apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          action: 'getComments',
          courseHandle: this._courseHandle,
          lessonId: this._lessonId
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.success && data.comments) {
          self._comments = data.comments;
        }
        self._renderComments();
      })
      .catch(function () {
        self._renderComments();
      });
    },

    _addComment: function (text, parentId) {
      if (!this._customer || !this._customer.loggedIn) return;

      var comment = {
        id: 'temp-' + Date.now(),
        name: this._customer.firstName || 'Student',
        email: this._customer.email || '',
        text: text,
        parentId: parentId,
        timestamp: new Date().toISOString(),
        pending: true
      };

      // Optimistic UI
      this._comments.push(comment);
      this._renderComments();

      var self = this;
      fetch(this._apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          action: 'addComment',
          courseHandle: this._courseHandle,
          lessonId: this._lessonId,
          name: comment.name,
          email: comment.email,
          text: comment.text,
          parentId: parentId
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Remove optimistic comment and replace with confirmed
        self._comments = self._comments.filter(function (c) { return c.id !== comment.id; });
        if (data.success && data.comment) {
          self._comments.push(data.comment);
        } else {
          comment.pending = false;
          self._comments.push(comment);
        }
        self._renderComments();
      })
      .catch(function () {
        comment.pending = false;
        comment.error = true;
        self._renderComments();
      });
    },

    _renderComments: function () {
      var el = document.getElementById('SaifDiscussionComments');
      if (!el) return;

      if (!this._comments.length) {
        el.innerHTML = '<p style="color:#6B6960;font-size:14px;text-align:center;padding:16px;">No comments yet. Be the first to start the discussion!</p>';
        return;
      }

      // Build threaded comments
      var topLevel = this._comments.filter(function (c) { return !c.parentId; });
      var self = this;

      var html = '';
      topLevel.forEach(function (comment) {
        html += self._renderComment(comment, 0);
      });

      el.innerHTML = html;

      // Bind reply buttons
      el.querySelectorAll('[data-reply-to]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var parentId = btn.getAttribute('data-reply-to');
          var replyBox = el.querySelector('[data-reply-box="' + parentId + '"]');
          if (replyBox) {
            replyBox.hidden = !replyBox.hidden;
            if (!replyBox.hidden) replyBox.querySelector('textarea').focus();
          }
        });
      });

      el.querySelectorAll('[data-reply-submit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var parentId = btn.getAttribute('data-reply-submit');
          var textarea = el.querySelector('[data-reply-box="' + parentId + '"] textarea');
          if (textarea && textarea.value.trim()) {
            self._addComment(textarea.value.trim(), parentId);
            textarea.value = '';
          }
        });
      });
    },

    _renderComment: function (comment, depth) {
      var indent = depth * 24;
      var self = this;

      var timeStr = '';
      try {
        var d = new Date(comment.timestamp);
        timeStr = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      } catch (e) { timeStr = ''; }

      var html = '<div class="saif-discussion__comment" style="margin-left:' + indent + 'px;margin-bottom:12px;' +
        'padding:12px 16px;background:#fff;border:1px solid rgba(0,0,0,0.06);border-radius:8px;">' +
        '<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">' +
          '<div style="width:28px;height:28px;border-radius:50%;background:#2D6A5A;color:#FAF7F2;' +
            'display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;">' +
            escapeHtml((comment.name || 'S').charAt(0).toUpperCase()) +
          '</div>' +
          '<span style="font-weight:600;font-size:13px;color:#1A1814;">' + escapeHtml(comment.name) + '</span>' +
          '<span style="font-size:12px;color:#6B6960;">' + escapeHtml(timeStr) + '</span>' +
          (comment.pending ? '<span style="font-size:11px;color:#8A6508;">posting...</span>' : '') +
        '</div>' +
        '<p style="font-size:14px;color:#3D3B2F;margin:0 0 8px;">' + escapeHtml(comment.text) + '</p>' +
        '<button data-reply-to="' + comment.id + '" type="button" ' +
          'style="font-size:12px;color:#2D6A5A;background:none;border:none;cursor:pointer;padding:0;font-weight:600;">Reply</button>' +
        '<div data-reply-box="' + comment.id + '" hidden style="margin-top:8px;">' +
          '<textarea placeholder="Write a reply..." style="width:100%;min-height:60px;padding:8px;border:1px solid rgba(0,0,0,0.1);' +
            'border-radius:6px;font-family:inherit;font-size:13px;resize:vertical;margin-bottom:6px;"></textarea>' +
          '<button data-reply-submit="' + comment.id + '" type="button" ' +
            'style="padding:6px 14px;background:#2D6A5A;color:#FAF7F2;border:none;border-radius:6px;cursor:pointer;font-size:12px;font-weight:600;">Post Reply</button>' +
        '</div>' +
      '</div>';

      // Render child comments
      var children = this._comments.filter(function (c) { return c.parentId === comment.id; });
      children.forEach(function (child) {
        html += self._renderComment(child, depth + 1);
      });

      return html;
    }
  };

  /* ============================================
     7. PERSONALIZED LEARNING PATH
     ============================================ */
  var SaifLearningPath = {
    init: function () {
      var container = document.getElementById('SaifLearningPath');
      if (!container) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      var quizAnswers = null;
      try {
        quizAnswers = JSON.parse(localStorage.getItem('saif_quiz_answers'));
      } catch (e) { /* ignore */ }

      if (!quizAnswers) {
        // No personalized-path data — the quiz never persists `saif_quiz_answers`,
        // and the path's taxonomy/lesson IDs are placeholder (dead links). Hide
        // the widget on the dashboard rather than show a confusing "take the quiz"
        // box to a logged-in student. It self-reveals if real path data lands.
        container.innerHTML = '';
        container.hidden = true;
        return;
      }
      container.hidden = false;

      var allProgress = getAllProgress(customer.customerId);
      var completedLessons = [];
      allProgress.forEach(function (p) {
        completedLessons = completedLessons.concat(p.completedLessons || []);
      });

      // Map answers to recommended order
      var recommendedPath = this._buildPath(quizAnswers);

      var html = '<h3 style="font-size:18px;font-weight:700;margin-bottom:8px;color:#1A1814;">Your Learning Path</h3>' +
        '<p style="font-size:14px;color:#6B6960;margin-bottom:16px;">Based on your goals, we recommend:</p>' +
        '<div class="saif-learning-path__list">';

      recommendedPath.forEach(function (item, idx) {
        var isComplete = completedLessons.indexOf(item.id) !== -1;
        html += '<div class="saif-learning-path__item" style="display:flex;align-items:center;gap:12px;padding:12px 16px;' +
          'background:#FAF7F2;border:1px solid rgba(184,134,11,0.15);border-radius:8px;margin-bottom:8px;">' +
          '<div style="width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;' +
            'background:' + (isComplete ? '#2D6A5A' : 'rgba(184,134,11,0.1)') + ';color:' + (isComplete ? '#FAF7F2' : '#8A6508') + ';' +
            'font-size:13px;font-weight:700;">' +
            (isComplete ? '\u2713' : (idx + 1)) +
          '</div>' +
          '<div style="flex:1;">' +
            '<div style="font-weight:600;font-size:14px;color:' + (isComplete ? '#2D6A5A' : '#1A1814') + ';">' +
              escapeHtml(item.title) +
            '</div>' +
            (item.reason ? '<div style="font-size:12px;color:#6B6960;">' + escapeHtml(item.reason) + '</div>' : '') +
          '</div>' +
          (item.courseHandle ? '<a href="' + saifPath('/pages/lesson?course=' + escapeHtml(item.courseHandle) + '&lesson=' + escapeHtml(item.id)) + '" ' +
            'style="font-size:12px;font-weight:600;color:#2D6A5A;text-decoration:none;">' +
            (isComplete ? 'Review' : 'Start') + '</a>' : '') +
        '</div>';
      });

      html += '</div>';
      container.innerHTML = html;
    },

    _buildPath: function (answers) {
      var path = [];
      var goal = answers.goal || '';
      var level = answers.level || 'beginner';

      // Default path structure based on common goals
      if (goal === 'quran' || goal === 'recitation') {
        path = [
          { id: 'breathing-foundations', title: 'Breathing Foundations', reason: 'The foundation of recitation', courseHandle: '' },
          { id: 'how-voice-works', title: 'How the Voice Works', reason: 'Understand your instrument', courseHandle: '' },
          { id: 'natural-voice', title: 'Finding Your Natural Voice', reason: 'Discover your natural voice', courseHandle: '' },
          { id: 'vocal-warmups', title: 'Daily Vocal Warmups', reason: 'Build a steady practice', courseHandle: '' },
          { id: 'beginner-mistakes', title: 'Common Beginner Mistakes', reason: 'Avoid the frequent pitfalls', courseHandle: '' },
          { id: 'vocal-tone', title: 'Vocal Tone, Warmth & Smoothness', reason: 'Deepen your vocal skill', courseHandle: '' }
        ];
      } else if (goal === 'conversation') {
        path = [
          { id: 'greetings', title: 'Greetings & Introductions', reason: 'Start speaking right away', courseHandle: '' },
          { id: 'daily-phrases', title: 'Daily Phrases', reason: 'Practical everyday Arabic', courseHandle: '' },
          { id: 'pronunciation-basics', title: 'Pronunciation Refinement', reason: 'Sound natural', courseHandle: '' },
          { id: 'vocabulary-building', title: 'Vocabulary Building', reason: 'Expand your word bank', courseHandle: '' },
          { id: 'sentence-structure', title: 'Sentence Structure', reason: 'Build complete thoughts', courseHandle: '' }
        ];
      } else {
        path = [
          { id: 'pronunciation-basics', title: 'Pronunciation Basics', reason: 'Start with fundamentals', courseHandle: '' },
          { id: 'arabic-alphabet', title: 'Arabic Alphabet', reason: 'Reading foundation', courseHandle: '' },
          { id: 'basic-vocabulary', title: 'Basic Vocabulary', reason: 'Build your word bank', courseHandle: '' },
          { id: 'simple-sentences', title: 'Simple Sentences', reason: 'Start communicating', courseHandle: '' }
        ];
      }

      // Adjust for skill level
      if (level === 'intermediate' || level === 'advanced') {
        path = path.slice(Math.floor(path.length / 3));
      }

      return path;
    }
  };

  /* ============================================
     8. LESSON TRANSCRIPTS
     ============================================ */
  var SaifTranscript = {
    init: function () {
      var container = document.getElementById('SaifLessonTranscript');
      if (!container) return;

      var transcriptData = readJSON('SaifTranscriptData');
      if (!transcriptData || !transcriptData.transcript || !transcriptData.transcript.length) {
        container.hidden = true;
        return;
      }

      var transcript = transcriptData.transcript;
      this._render(container, transcript);
    },

    _render: function (container, transcript) {
      var html = '<div class="saif-transcript">' +
        '<button id="SaifTranscriptToggle" type="button" class="saif-transcript__toggle" ' +
          'style="display:flex;align-items:center;gap:8px;padding:10px 16px;background:#FAF7F2;' +
          'border:1px solid rgba(184,134,11,0.15);border-radius:8px;cursor:pointer;font-size:14px;' +
          'font-weight:600;color:#1A1814;width:100%;text-align:left;">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>' +
            '<line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>' +
          '</svg>' +
          '<span id="SaifTranscriptToggleText">Show Transcript</span>' +
        '</button>' +
        '<div id="SaifTranscriptContent" hidden style="margin-top:12px;padding:16px;background:#FAF7F2;' +
          'border:1px solid rgba(184,134,11,0.15);border-radius:8px;max-height:400px;overflow-y:auto;">';

      transcript.forEach(function (entry) {
        html += '<div class="saif-transcript__entry" data-transcript-time="' + escapeHtml(entry.time) + '" ' +
          'style="display:flex;gap:12px;padding:8px 0;border-bottom:1px solid rgba(0,0,0,0.04);cursor:pointer;' +
          'transition:background 0.2s ease;" ' +
          'tabindex="0" role="button">' +
          '<span class="saif-transcript__time" style="font-size:13px;font-weight:600;color:#8A6508;white-space:nowrap;min-width:48px;">' +
            escapeHtml(entry.time) +
          '</span>' +
          '<span class="saif-transcript__text" style="font-size:14px;color:#3D3B2F;line-height:1.5;">' +
            escapeHtml(entry.text) +
          '</span>' +
        '</div>';
      });

      html += '</div></div>';
      container.innerHTML = html;

      // Toggle visibility
      var toggle = document.getElementById('SaifTranscriptToggle');
      var content = document.getElementById('SaifTranscriptContent');
      var toggleText = document.getElementById('SaifTranscriptToggleText');

      toggle.addEventListener('click', function () {
        content.hidden = !content.hidden;
        toggleText.textContent = content.hidden ? 'Show Transcript' : 'Hide Transcript';
      });

      // Click timestamp to seek video
      container.querySelectorAll('[data-transcript-time]').forEach(function (entry) {
        entry.addEventListener('click', function () {
          var timeStr = entry.getAttribute('data-transcript-time');
          var seconds = SaifTranscript._timeToSeconds(timeStr);
          SaifTranscript._seekVideo(seconds);

          // Highlight current entry
          container.querySelectorAll('.saif-transcript__entry').forEach(function (e) {
            e.style.background = '';
          });
          entry.style.background = 'rgba(184, 134, 11, 0.08)';
        });

        entry.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            entry.click();
          }
        });
      });

      // Try to sync with video playback
      this._startSync(container, transcript);
    },

    _timeToSeconds: function (timeStr) {
      var parts = timeStr.split(':').map(Number);
      if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
      if (parts.length === 2) return parts[0] * 60 + parts[1];
      return parts[0] || 0;
    },

    _seekVideo: function (seconds) {
      // Try YouTube iframe API
      var iframe = document.querySelector('.saif-lesson__video iframe');
      if (!iframe) return;

      var src = iframe.src || '';
      if (src.indexOf('youtube') !== -1 || src.indexOf('youtu.be') !== -1) {
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: 'seekTo',
          args: [seconds, true]
        }), '*');
      } else if (src.indexOf('vimeo') !== -1) {
        iframe.contentWindow.postMessage(JSON.stringify({
          method: 'setCurrentTime',
          value: seconds
        }), '*');
      }
    },

    _startSync: function (container, transcript) {
      // Listen for postMessage from video iframes to get current time
      var entries = container.querySelectorAll('.saif-transcript__entry');
      if (!entries.length) return;

      window.addEventListener('message', function (e) {
        var data;
        try { data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (err) { return; }

        var currentTime = null;
        // YouTube
        if (data.info && typeof data.info.currentTime === 'number') {
          currentTime = data.info.currentTime;
        }
        // Vimeo
        if (data.method === 'playProgress' && data.value && typeof data.value.seconds === 'number') {
          currentTime = data.value.seconds;
        }

        if (currentTime === null) return;

        // Find closest transcript entry
        var activeEntry = null;
        entries.forEach(function (entry) {
          var timeStr = entry.getAttribute('data-transcript-time');
          var secs = SaifTranscript._timeToSeconds(timeStr);
          if (secs <= currentTime) activeEntry = entry;
        });

        entries.forEach(function (entry) {
          entry.style.background = (entry === activeEntry) ? 'rgba(184, 134, 11, 0.08)' : '';
        });

        if (activeEntry) {
          var contentEl = document.getElementById('SaifTranscriptContent');
          if (contentEl && !contentEl.hidden) {
            activeEntry.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }
      });
    }
  };

  /* ============================================
     9. SPACED REPETITION / REVIEW PROMPTS
     ============================================ */
  var SaifReview = {
    _intervals: [1, 3, 7, 14], // days

    init: function () {
      var container = document.getElementById('SaifReviewPrompts');
      if (!container) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      var reviews = this._getReviews(customer.customerId);
      var due = this._getDueReviews(reviews);

      if (due.length === 0) {
        // Nothing due — hide the widget entirely rather than showing an empty
        // "No lessons to review" box, which reads as broken to new students.
        // The spaced-repetition prompt only appears once a review is actually due.
        container.innerHTML = '';
        container.hidden = true;
        return;
      }
      container.hidden = false;

      this._render(container, due, customer.customerId);

      // Listen for lesson completion to schedule reviews
      var self = this;
      document.addEventListener('saif:lessonComplete', function (e) {
        if (e.detail && e.detail.lessonId && e.detail.courseHandle) {
          self.scheduleReview(customer.customerId, e.detail.courseHandle, e.detail.lessonId, e.detail.lessonTitle || '');
        }
      });
    },

    _storageKey: function (customerId) {
      return 'saif_reviews_' + customerId;
    },

    _getReviews: function (customerId) {
      try {
        var d = localStorage.getItem(this._storageKey(customerId));
        return d ? JSON.parse(d) : [];
      } catch (e) { return []; }
    },

    _saveReviews: function (customerId, reviews) {
      try {
        localStorage.setItem(this._storageKey(customerId), JSON.stringify(reviews));
      } catch (e) { /* storage unavailable */ }
    },

    scheduleReview: function (customerId, courseHandle, lessonId, lessonTitle) {
      var reviews = this._getReviews(customerId);

      // Remove existing reviews for this lesson
      reviews = reviews.filter(function (r) {
        return !(r.courseHandle === courseHandle && r.lessonId === lessonId);
      });

      // Schedule first review (+1 day)
      var nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + this._intervals[0]);

      reviews.push({
        courseHandle: courseHandle,
        lessonId: lessonId,
        lessonTitle: lessonTitle,
        nextReview: nextDate.toISOString(),
        intervalIndex: 0,
        completedAt: new Date().toISOString()
      });

      this._saveReviews(customerId, reviews);
    },

    _getDueReviews: function (reviews) {
      var now = new Date();
      return reviews.filter(function (r) {
        return new Date(r.nextReview) <= now;
      }).sort(function (a, b) {
        return new Date(a.nextReview) - new Date(b.nextReview);
      });
    },

    _render: function (container, dueReviews, customerId) {
      var self = this;
      var now = new Date();
      var todayStr = now.toISOString().split('T')[0];

      var html = '<h3 style="font-size:18px;font-weight:700;margin-bottom:12px;color:#1A1814;">Lessons to Review</h3>';

      dueReviews.forEach(function (review, idx) {
        var reviewDate = new Date(review.nextReview);
        var isOverdue = reviewDate < new Date(todayStr);
        var isDueToday = reviewDate.toISOString().split('T')[0] === todayStr;

        html += '<div class="saif-review__item" style="display:flex;align-items:center;gap:12px;padding:12px 16px;' +
          'background:#FAF7F2;border:1px solid ' + (isOverdue ? 'rgba(192,57,43,0.3)' : isDueToday ? 'rgba(184,134,11,0.3)' : 'rgba(0,0,0,0.06)') +
          ';border-radius:8px;margin-bottom:8px;">' +
          '<div style="width:10px;height:10px;border-radius:50%;flex-shrink:0;background:' +
            (isOverdue ? '#C0392B' : '#B8860B') + ';"></div>' +
          '<div style="flex:1;">' +
            '<div style="font-weight:600;font-size:14px;color:#1A1814;">' + escapeHtml(review.lessonTitle || review.lessonId) + '</div>' +
            '<div style="font-size:12px;color:' + (isOverdue ? '#C0392B' : '#6B6960') + ';">' +
              (isOverdue ? 'Overdue' : 'Due today') +
            '</div>' +
          '</div>' +
          '<div style="display:flex;gap:8px;">' +
            '<a href="' + saifPath('/pages/lesson?course=' + escapeHtml(review.courseHandle) + '&lesson=' + escapeHtml(review.lessonId)) + '" ' +
              'style="padding:6px 14px;background:#2D6A5A;color:#FAF7F2;border-radius:6px;font-size:12px;font-weight:600;text-decoration:none;">Review</a>' +
            '<button type="button" data-review-done="' + idx + '" ' +
              'style="padding:6px 14px;background:transparent;border:1px solid rgba(0,0,0,0.1);border-radius:6px;font-size:12px;' +
              'font-weight:600;color:#6B6960;cursor:pointer;">Mark Reviewed</button>' +
          '</div>' +
        '</div>';
      });

      container.innerHTML = html;

      // Bind "Mark as Reviewed" buttons
      container.querySelectorAll('[data-review-done]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var reviewIdx = parseInt(btn.getAttribute('data-review-done'));
          var review = dueReviews[reviewIdx];
          if (!review) return;

          var reviews = self._getReviews(customerId);
          var found = reviews.filter(function (r) {
            return r.courseHandle === review.courseHandle && r.lessonId === review.lessonId;
          })[0];

          if (found) {
            // Advance to next interval
            var nextIntervalIdx = (found.intervalIndex || 0) + 1;
            if (nextIntervalIdx < self._intervals.length) {
              var nextDate = new Date();
              nextDate.setDate(nextDate.getDate() + self._intervals[nextIntervalIdx]);
              found.nextReview = nextDate.toISOString();
              found.intervalIndex = nextIntervalIdx;
            } else {
              // All intervals done, remove from review
              reviews = reviews.filter(function (r) {
                return !(r.courseHandle === review.courseHandle && r.lessonId === review.lessonId);
              });
            }
          }

          self._saveReviews(customerId, reviews);

          // Re-render
          var newDue = self._getDueReviews(self._getReviews(customerId));
          if (newDue.length > 0) {
            self._render(container, newDue, customerId);
          } else {
            container.innerHTML = '<div style="padding:16px;text-align:center;color:#2D6A5A;font-size:14px;">' +
              '<p>All caught up! No reviews due.</p></div>';
          }
        });
      });
    }
  };

  /* ============================================
     10. SOCIAL SHARING FOR ACHIEVEMENTS
     ============================================ */
  var SaifShare = {
    show: function (type, detail) {
      var customer = getCustomer();
      var customerId = customer ? customer.customerId : '';

      var text = '';
      var url = window.location.origin;

      if (type === 'badge') {
        text = 'I just earned the "' + detail + '" badge on Saif! ' + url;
      } else if (type === 'course') {
        text = 'I just completed "' + detail + '" on Saif! ' + url;
      } else {
        text = 'Check out Saif! ' + url;
      }

      var encodedText = encodeURIComponent(text);
      var encodedUrl = encodeURIComponent(url);

      var modal = document.createElement('div');
      modal.className = 'saif-share-modal';
      modal.style.cssText = 'position:fixed;inset:0;z-index:100002;display:flex;align-items:center;justify-content:center;' +
        'background:rgba(0,0,0,0.5);';
      modal.innerHTML =
        '<div role="dialog" aria-modal="true" aria-labelledby="SaifShareModalTitle" ' +
          'style="background:#FAF7F2;border-radius:16px;padding:28px;max-width:400px;width:90%;position:relative;">' +
          '<button class="saif-share-modal__close" type="button" ' +
            'style="position:absolute;top:4px;right:4px;width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;background:none;border:none;font-size:20px;cursor:pointer;color:#6B6960;" ' +
            'aria-label="Close">&times;</button>' +
          '<h3 id="SaifShareModalTitle" style="font-size:18px;font-weight:700;margin-bottom:16px;color:#1A1814;">Share Your Achievement</h3>' +
          '<div style="display:flex;flex-direction:column;gap:10px;">' +
            '<a href="https://twitter.com/intent/tweet?text=' + encodedText + '" target="_blank" rel="noopener" ' +
              'style="display:flex;align-items:center;gap:10px;padding:12px 16px;background:#1A1814;color:#FAF7F2;' +
              'border-radius:8px;text-decoration:none;font-weight:600;font-size:14px;" data-share-platform="twitter">' +
              'Share on X (Twitter)' +
            '</a>' +
            '<a href="https://wa.me/?text=' + encodedText + '" target="_blank" rel="noopener" ' +
              'style="display:flex;align-items:center;gap:10px;padding:12px 16px;background:#25D366;color:#fff;' +
              'border-radius:8px;text-decoration:none;font-weight:600;font-size:14px;" data-share-platform="whatsapp">' +
              'Share on WhatsApp' +
            '</a>' +
            '<a href="https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl + '&quote=' + encodedText + '" target="_blank" rel="noopener" ' +
              'style="display:flex;align-items:center;gap:10px;padding:12px 16px;background:#1877F2;color:#fff;' +
              'border-radius:8px;text-decoration:none;font-weight:600;font-size:14px;" data-share-platform="facebook">' +
              'Share on Facebook' +
            '</a>' +
            '<button id="SaifShareCopyLink" type="button" ' +
              'style="display:flex;align-items:center;gap:10px;padding:12px 16px;background:#FAF7F2;color:#1A1814;' +
              'border:1px solid rgba(0,0,0,0.1);border-radius:8px;cursor:pointer;font-weight:600;font-size:14px;">' +
              'Copy Link' +
            '</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(modal);

      // Track shares
      modal.querySelectorAll('[data-share-platform]').forEach(function (link) {
        link.addEventListener('click', function () {
          SaifShare._trackShare(customerId, link.getAttribute('data-share-platform'));
        });
      });

      // Close (Escape + focus trap + focus restore via saifTrapModal)
      var closeModal = function () {
        releaseTrap();
        modal.remove();
      };
      var releaseTrap = saifTrapModal(modal, closeModal);
      modal.querySelector('.saif-share-modal__close').addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });

      // Copy link
      document.getElementById('SaifShareCopyLink').addEventListener('click', function () {
        navigator.clipboard.writeText(text).then(function () {
          var btn = document.getElementById('SaifShareCopyLink');
          btn.textContent = 'Copied!';
          SaifShare._trackShare(customerId, 'copy');
          setTimeout(function () { btn.textContent = 'Copy Link'; }, 2000);
        }).catch(function () {
          // Fallback
          var textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          try { document.execCommand('copy'); } catch (e) { /* ignore */ }
          document.body.removeChild(textarea);
          var btn = document.getElementById('SaifShareCopyLink');
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = 'Copy Link'; }, 2000);
        });
      });
    },

    _trackShare: function (customerId, platform) {
      if (!customerId) return;
      try {
        var key = 'saif_shares_' + customerId;
        var shares = JSON.parse(localStorage.getItem(key) || '[]');
        shares.push({ platform: platform, timestamp: new Date().toISOString() });
        localStorage.setItem(key, JSON.stringify(shares));
      } catch (e) { /* ignore */ }

      // Fire analytics event
      if (typeof gtag === 'function') {
        gtag('event', 'share', { method: platform, content_type: 'achievement' });
      }
      document.dispatchEvent(new CustomEvent('saif:analytics', {
        detail: { action: 'share', label: platform }
      }));
    }
  };

  /* ============================================
     11. GIFT A COURSE
     ============================================ */
  var SaifGift = {
    init: function () {
      var btns = document.querySelectorAll('.saif-gift__btn');
      if (!btns.length) return;

      var self = this;
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var variantId = btn.getAttribute('data-variant-id');
          var productTitle = btn.getAttribute('data-product-title') || 'Course';
          self._showModal(variantId, productTitle);
        });
      });
    },

    _showModal: function (variantId, productTitle) {
      var self = this;
      var modal = document.createElement('div');
      modal.className = 'saif-gift-modal';
      modal.style.cssText = 'position:fixed;inset:0;z-index:100002;display:flex;align-items:center;justify-content:center;' +
        'background:rgba(0,0,0,0.5);';
      modal.innerHTML =
        '<div class="saif-gift-modal__content" role="dialog" aria-modal="true" aria-labelledby="SaifGiftModalTitle" ' +
          'style="background:#FAF7F2;border-radius:16px;padding:28px;max-width:440px;width:90%;position:relative;">' +
          '<button class="saif-gift-modal__close" type="button" ' +
            'style="position:absolute;top:4px;right:4px;width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;background:none;border:none;font-size:20px;cursor:pointer;color:#6B6960;" ' +
            'aria-label="Close">&times;</button>' +
          '<h3 id="SaifGiftModalTitle" style="font-size:18px;font-weight:700;margin-bottom:4px;color:#1A1814;">Gift This Course</h3>' +
          '<p style="font-size:14px;color:#6B6960;margin-bottom:20px;">' + escapeHtml(productTitle) + '</p>' +
          '<form id="SaifGiftForm">' +
            '<div style="margin-bottom:12px;">' +
              '<label for="SaifGiftRecipientName" style="display:block;font-size:13px;font-weight:600;color:#1A1814;margin-bottom:4px;">Recipient Name</label>' +
              '<input type="text" id="SaifGiftRecipientName" required ' +
                'style="width:100%;padding:10px 12px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;font-size:14px;font-family:inherit;background:#fff;">' +
            '</div>' +
            '<div style="margin-bottom:12px;">' +
              '<label for="SaifGiftRecipientEmail" style="display:block;font-size:13px;font-weight:600;color:#1A1814;margin-bottom:4px;">Recipient Email</label>' +
              '<input type="email" id="SaifGiftRecipientEmail" required ' +
                'style="width:100%;padding:10px 12px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;font-size:14px;font-family:inherit;background:#fff;">' +
            '</div>' +
            '<div style="margin-bottom:16px;">' +
              '<label for="SaifGiftMessage" style="display:block;font-size:13px;font-weight:600;color:#1A1814;margin-bottom:4px;">Gift Message (optional)</label>' +
              '<textarea id="SaifGiftMessage" rows="3" ' +
                'style="width:100%;padding:10px 12px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;font-size:14px;font-family:inherit;resize:vertical;background:#fff;"' +
                '></textarea>' +
            '</div>' +
            '<div id="SaifGiftError" role="alert" hidden style="color:#C0392B;font-size:13px;margin-bottom:12px;"></div>' +
            '<button type="submit" id="SaifGiftSubmit" ' +
              'style="width:100%;padding:12px;background:#8A6508;color:#FAF7F2;border:none;border-radius:8px;cursor:pointer;' +
              'font-size:15px;font-weight:700;">Add Gift to Cart</button>' +
          '</form>' +
        '</div>';

      document.body.appendChild(modal);

      // Close handlers (Escape + focus trap + focus restore via saifTrapModal)
      var closeModal = function () {
        releaseTrap();
        modal.remove();
      };
      var releaseTrap = saifTrapModal(modal, closeModal);
      modal.querySelector('.saif-gift-modal__close').addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });

      // Form submission
      document.getElementById('SaifGiftForm').addEventListener('submit', function (e) {
        e.preventDefault();
        var recipientName = document.getElementById('SaifGiftRecipientName').value.trim();
        var recipientEmail = document.getElementById('SaifGiftRecipientEmail').value.trim();
        var message = document.getElementById('SaifGiftMessage').value.trim();
        var errorEl = document.getElementById('SaifGiftError');
        var submitBtn = document.getElementById('SaifGiftSubmit');

        if (!recipientName || !recipientEmail) {
          errorEl.textContent = 'Please fill in all required fields.';
          errorEl.hidden = false;
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';

        var properties = {
          '_gift': 'true',
          'Recipient Name': recipientName,
          'Recipient Email': recipientEmail
        };
        if (message) properties['Gift Message'] = message;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: 1,
              properties: properties
            }]
          })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('Could not add to cart.');
          return r.json();
        })
        .then(function () {
          closeModal();
          // Redirect to cart
          window.location.href = '/cart';
        })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add Gift to Cart';
        });
      });
    }
  };

  /* ============================================
     12. UPSELL ON COMPLETION
     ============================================ */
  var SaifUpsell = {
    init: function () {
      var config = readJSON('SaifUpsellConfig');
      if (!config) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      // Check if already dismissed
      var dismissKey = 'saif_upsell_dismissed_' + config.courseHandle;
      try {
        if (localStorage.getItem(dismissKey) === 'true') return;
      } catch (e) { /* ignore */ }

      // Check if course is complete
      var allProgress = getAllProgress(customer.customerId);
      var progress = allProgress.filter(function (p) { return p.courseHandle === config.courseHandle; })[0];
      if (!progress) return;

      var total = config.totalLessons || 0;
      if (total <= 0) return;
      var pct = Math.round(((progress.completedLessons || []).length / total) * 100);

      if (pct < 100) return;

      // Auto-open at most once per course/page (REQ-MODAL-005)
      var shownKey = 'saif_upsell_shown_' + (config.courseHandle || location.pathname);
      try {
        if (localStorage.getItem(shownKey) === 'true') return;
      } catch (e) { /* ignore */ }

      // Delay to show after celebration
      var self = this;
      setTimeout(function () {
        try { localStorage.setItem(shownKey, 'true'); } catch (e) { /* ignore */ }
        self._showModal(config, dismissKey);
      }, 3500);
    },

    _showModal: function (config, dismissKey) {
      var modal = document.createElement('div');
      modal.className = 'saif-upsell-modal';
      modal.style.cssText = 'position:fixed;inset:0;z-index:100003;display:flex;align-items:center;justify-content:center;' +
        'background:rgba(0,0,0,0.5);';
      modal.innerHTML =
        '<div role="dialog" aria-modal="true" aria-labelledby="SaifUpsellModalTitle" ' +
          'style="background:#FAF7F2;border-radius:16px;padding:32px;max-width:480px;width:90%;position:relative;text-align:center;">' +
          '<button class="saif-upsell-modal__close" type="button" ' +
            'style="position:absolute;top:4px;right:4px;width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;background:none;border:none;font-size:20px;cursor:pointer;color:#6B6960;" ' +
            'aria-label="Close">&times;</button>' +
          '<div style="font-size:40px;margin-bottom:12px;">\uD83C\uDF89</div>' +
          '<h3 id="SaifUpsellModalTitle" style="font-size:22px;font-weight:700;margin-bottom:8px;color:#1A1814;">Continue Your Journey</h3>' +
          '<p style="font-size:14px;color:#6B6960;margin-bottom:20px;">' +
            'You\'ve completed this course! Ready for the next step?' +
          '</p>' +
          (config.nextCourse ? (
            '<div style="background:#fff;border:1px solid rgba(184,134,11,0.2);border-radius:12px;padding:20px;margin-bottom:20px;text-align:left;">' +
              (config.nextCourse.image ? '<img src="' + escapeHtml(config.nextCourse.image) + '" alt="" ' +
                'style="width:100%;border-radius:8px;margin-bottom:12px;">' : '') +
              '<h4 style="font-size:16px;font-weight:700;margin-bottom:4px;color:#1A1814;">' + escapeHtml(config.nextCourse.title) + '</h4>' +
              '<p style="font-size:13px;color:#6B6960;margin-bottom:12px;">' + escapeHtml(config.nextCourse.description || '') + '</p>' +
              (config.nextCourse.price ? '<div style="font-size:18px;font-weight:700;color:#8A6508;">' + escapeHtml(config.nextCourse.price) + '</div>' : '') +
            '</div>' +
            '<a href="' + escapeHtml(config.nextCourse.url || saifPath('/collections/all')) + '" ' +
              'style="display:inline-block;padding:14px 32px;background:#8A6508;color:#FAF7F2;border-radius:8px;' +
              'text-decoration:none;font-weight:700;font-size:15px;">Join Now</a>'
          ) : '<a href="' + saifPath('/collections/all') + '" style="display:inline-block;padding:14px 32px;background:#8A6508;color:#FAF7F2;' +
              'border-radius:8px;text-decoration:none;font-weight:700;font-size:15px;">Browse Courses</a>') +
          '<div style="margin-top:12px;">' +
            '<button class="saif-upsell-modal__dismiss" type="button" ' +
              'style="background:none;border:none;color:#6B6960;font-size:13px;cursor:pointer;text-decoration:underline;">Maybe later</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(modal);

      var closeModal = function () {
        try { localStorage.setItem(dismissKey, 'true'); } catch (e) { /* ignore */ }
        releaseTrap();
        modal.remove();
      };
      var releaseTrap = saifTrapModal(modal, closeModal);

      modal.querySelector('.saif-upsell-modal__close').addEventListener('click', closeModal);
      modal.querySelector('.saif-upsell-modal__dismiss').addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }
  };

  /* ============================================
     13. REFERRAL CODE
     ============================================ */
  var SaifReferral = {
    init: function () {
      var config = readJSON('SaifReferralConfig');
      var container = document.getElementById('SaifReferralConfig');
      if (!container) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      var shopUrl = config && config.shopUrl ? config.shopUrl : window.location.origin;
      var referralLink = shopUrl + '?ref=' + customer.customerId;

      var wrapper = container.parentElement || container;
      var html = '<div class="saif-referral" style="background:#FAF7F2;border:1px solid rgba(184,134,11,0.15);border-radius:12px;padding:20px;">' +
        '<h3 style="font-size:16px;font-weight:700;margin-bottom:8px;color:#1A1814;">Refer a Friend</h3>' +
        '<p style="font-size:14px;color:#6B6960;margin-bottom:12px;">Share your personal referral link:</p>' +
        '<div style="display:flex;gap:8px;margin-bottom:12px;">' +
          '<input type="text" id="SaifReferralLink" readonly aria-label="Your referral link" value="' + escapeHtml(referralLink) + '" ' +
            'style="flex:1;padding:10px 12px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;font-size:13px;' +
            'font-family:inherit;background:#fff;color:#1A1814;">' +
          '<button id="SaifReferralCopy" type="button" ' +
            'style="padding:10px 16px;background:#8A6508;color:#FAF7F2;border:none;border-radius:8px;cursor:pointer;' +
            'font-size:13px;font-weight:600;white-space:nowrap;">Copy</button>' +
        '</div>' +
        '<div style="display:flex;gap:8px;flex-wrap:wrap;">' +
          '<a href="https://wa.me/?text=' + encodeURIComponent('Check out Saif! ' + referralLink) + '" target="_blank" rel="noopener" ' +
            'style="padding:8px 14px;background:#25D366;color:#fff;border-radius:6px;font-size:12px;font-weight:600;text-decoration:none;">WhatsApp</a>' +
          '<a href="mailto:?subject=' + encodeURIComponent('Check out Saif!') + '&body=' + encodeURIComponent('I\'ve been learning with Saif and thought you might enjoy it too: ' + referralLink) + '" ' +
            'style="padding:8px 14px;background:#1A1814;color:#FAF7F2;border-radius:6px;font-size:12px;font-weight:600;text-decoration:none;">Email</a>' +
          '<a href="https://twitter.com/intent/tweet?text=' + encodeURIComponent('Check out Saif! ' + referralLink) + '" target="_blank" rel="noopener" ' +
            'style="padding:8px 14px;background:#1A1814;color:#FAF7F2;border-radius:6px;font-size:12px;font-weight:600;text-decoration:none;">X (Twitter)</a>' +
        '</div>' +
      '</div>';

      // Insert after the script tag
      var renderTarget = document.createElement('div');
      renderTarget.innerHTML = html;
      wrapper.appendChild(renderTarget);

      // Copy button
      document.getElementById('SaifReferralCopy').addEventListener('click', function () {
        var input = document.getElementById('SaifReferralLink');
        navigator.clipboard.writeText(input.value).then(function () {
          var btn = document.getElementById('SaifReferralCopy');
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
        }).catch(function () {
          input.select();
          try { document.execCommand('copy'); } catch (e) { /* ignore */ }
          var btn = document.getElementById('SaifReferralCopy');
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
        });
      });
    }
  };

  /* ============================================
     14. COUNTDOWN TIMER ENHANCEMENT
     ============================================ */
  var SaifCountdownStandalone = {
    init: function () {
      var els = document.querySelectorAll('[data-saif-countdown-standalone]');
      if (!els.length) return;

      els.forEach(function (el) {
        var targetDate = el.getAttribute('data-saif-countdown-standalone');
        if (!targetDate) return;

        var target = new Date(targetDate).getTime();
        if (isNaN(target)) return;

        // Create digit elements
        var units = ['days', 'hours', 'minutes', 'seconds'];
        el.innerHTML = '<div class="saif-countdown" style="display:flex;gap:16px;justify-content:center;">' +
          units.map(function (unit) {
            return '<div class="saif-countdown__unit" style="text-align:center;">' +
              '<div class="saif-countdown__digits" data-countdown-digits="' + unit + '" ' +
                'style="font-size:32px;font-weight:700;color:#B8860B;font-variant-numeric:tabular-nums;' +
                'min-width:48px;position:relative;overflow:hidden;line-height:1;">00</div>' +
              '<div style="font-size:11px;text-transform:uppercase;letter-spacing:0.1em;color:#6B6960;margin-top:4px;">' +
                unit + '</div>' +
            '</div>';
          }).join('<div style="font-size:28px;font-weight:700;color:rgba(184,134,11,0.3);line-height:1;">:</div>') +
        '</div>';

        function update() {
          var now = Date.now();
          var diff = Math.max(0, target - now);

          var d = Math.floor(diff / 86400000);
          var h = Math.floor((diff % 86400000) / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);

          var values = { days: d, hours: h, minutes: m, seconds: s };

          units.forEach(function (unit) {
            var digitEl = el.querySelector('[data-countdown-digits="' + unit + '"]');
            if (!digitEl) return;

            var newVal = (values[unit] < 10 ? '0' : '') + values[unit];
            var oldVal = digitEl.textContent;

            if (newVal !== oldVal) {
              // Flip animation
              if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                digitEl.classList.remove('saif-countdown__flip');
                void digitEl.offsetWidth; // Force reflow
                digitEl.classList.add('saif-countdown__flip');
              }
              digitEl.textContent = newVal;
            }
          });

          if (diff <= 0) {
            clearInterval(timer);
          }
        }

        update();
        var timer = setInterval(update, 1000);
      });

      // Inject flip animation CSS if not present
      if (!document.getElementById('SaifCountdownStyles')) {
        var style = document.createElement('style');
        style.id = 'SaifCountdownStyles';
        style.textContent = '@keyframes saif-flip{0%{transform:rotateX(0)}50%{transform:rotateX(-90deg)}100%{transform:rotateX(0)}}' +
          '.saif-countdown__flip{animation:saif-flip 0.4s ease;}';
        document.head.appendChild(style);
      }
    }
  };

  /* ============================================
     15. GLOSSARY SEARCH & FILTER
     ============================================ */
  var SaifGlossary = {
    init: function () {
      var data = readJSON('SaifGlossaryData');
      if (!data || !data.terms || !data.terms.length) return;

      var container = document.getElementById('SaifGlossaryData');
      if (!container) return;

      var wrapper = container.parentElement || document.body;
      this._render(wrapper, data.terms);
    },

    _render: function (wrapper, terms) {
      // Extract unique first letters
      var letters = [];
      terms.forEach(function (t) {
        var letter = (t.term || '').charAt(0).toUpperCase();
        if (letter && letters.indexOf(letter) === -1) letters.push(letter);
      });
      letters.sort();

      var renderTarget = document.createElement('div');
      renderTarget.className = 'saif-glossary';

      var html = '<div class="saif-glossary__controls" style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px;align-items:center;">' +
        '<input type="text" id="SaifGlossarySearch" placeholder="Search terms..." ' +
          'style="flex:1;min-width:200px;padding:10px 14px;border:1px solid rgba(0,0,0,0.1);border-radius:8px;' +
          'font-size:14px;font-family:inherit;background:#fff;color:#1A1814;">' +
        '<span id="SaifGlossaryCount" aria-live="polite" ' +
          'style="font-size:13px;color:#6B6960;white-space:nowrap;"></span>' +
      '</div>' +
      '<div class="saif-glossary__alphabet" id="SaifGlossaryAlphabet" style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:16px;">';

      html += '<button class="saif-glossary__letter saif-glossary__letter--active" data-letter="all" type="button" ' +
        'style="padding:6px 10px;border:1px solid rgba(184,134,11,0.2);border-radius:6px;background:#8A6508;color:#FAF7F2;' +
        'cursor:pointer;font-size:13px;font-weight:600;">All</button>';

      letters.forEach(function (letter) {
        html += '<button class="saif-glossary__letter" data-letter="' + letter + '" type="button" ' +
          'style="padding:6px 10px;border:1px solid rgba(184,134,11,0.2);border-radius:6px;background:#FAF7F2;color:#1A1814;' +
          'cursor:pointer;font-size:13px;font-weight:600;">' + letter + '</button>';
      });

      html += '</div><div class="saif-glossary__terms" id="SaifGlossaryTerms">';

      terms.forEach(function (t) {
        var letter = (t.term || '').charAt(0).toUpperCase();
        html += '<div class="saif-glossary__term" data-term-letter="' + letter + '" ' +
          'data-term-text="' + escapeHtml((t.term || '').toLowerCase()) + '" ' +
          'style="padding:16px;background:#FAF7F2;border:1px solid rgba(184,134,11,0.1);border-radius:8px;margin-bottom:8px;">' +
          '<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px;">' +
            '<h4 style="font-size:16px;font-weight:700;color:#1A1814;margin:0;">' + escapeHtml(t.term) + '</h4>' +
            (t.transliteration ? '<span style="font-size:13px;color:#8A6508;font-style:italic;">' + escapeHtml(t.transliteration) + '</span>' : '') +
            (t.audio ? '<button class="saif-glossary__audio-btn" data-audio-src="' + escapeHtml(t.audio) + '" type="button" ' +
              'style="padding:4px 8px;background:none;border:1px solid rgba(184,134,11,0.3);border-radius:4px;cursor:pointer;font-size:12px;color:#8A6508;" ' +
              'aria-label="Play pronunciation">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>' +
            '</button>' : '') +
          '</div>' +
          '<p style="font-size:14px;color:#3D3B2F;margin:0;">' + escapeHtml(t.definition) + '</p>' +
        '</div>';
      });

      html += '</div>';
      renderTarget.innerHTML = html;
      wrapper.appendChild(renderTarget);

      // Search
      var searchInput = document.getElementById('SaifGlossarySearch');
      var termCards = renderTarget.querySelectorAll('.saif-glossary__term');

      // Result count (REQ-SEARCH-006)
      var countEl = document.getElementById('SaifGlossaryCount');
      function updateCount() {
        if (!countEl) return;
        var visible = 0;
        termCards.forEach(function (card) {
          if (card.style.display !== 'none') visible++;
        });
        countEl.textContent = visible + (visible === 1 ? ' term' : ' terms');
      }
      updateCount();

      searchInput.addEventListener('input', function () {
        var query = searchInput.value.toLowerCase().trim();
        termCards.forEach(function (card) {
          var text = card.getAttribute('data-term-text') || '';
          card.style.display = (!query || text.indexOf(query) !== -1) ? '' : 'none';
        });
        updateCount();
      });

      // Alphabet filter
      var letterBtns = renderTarget.querySelectorAll('.saif-glossary__letter');
      letterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          letterBtns.forEach(function (b) {
            b.style.background = '#FAF7F2';
            b.style.color = '#1A1814';
          });
          btn.style.background = '#8A6508';
          btn.style.color = '#FAF7F2';

          var letter = btn.getAttribute('data-letter');
          termCards.forEach(function (card) {
            if (letter === 'all') {
              card.style.display = '';
            } else {
              card.style.display = card.getAttribute('data-term-letter') === letter ? '' : 'none';
            }
          });

          searchInput.value = '';
          updateCount();
        });
      });

      // Audio playback
      renderTarget.querySelectorAll('.saif-glossary__audio-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-audio-src');
          if (!src) return;
          var audio = new Audio(src);
          audio.play().catch(function () { /* autoplay blocked */ });
        });
      });
    }
  };

  /* ============================================
     16. SIDE-BY-SIDE AUDIO COMPARISON
     ============================================ */
  var SaifAudioCompare = {
    _audioCtx: null,

    init: function () {
      var container = document.getElementById('SaifLessonCompare');
      if (!container) return;

      var teacherSrc = container.getAttribute('data-teacher-src') || '';
      var studentSrc = container.getAttribute('data-student-src') || '';

      this._render(container, teacherSrc, studentSrc);
    },

    _render: function (container, teacherSrc, studentSrc) {
      var self = this;

      // Editorial markup — class-based so the lesson-page CSS controls
      // typography, colors, and ornaments. No more inline styles fighting
      // with the manuscript aesthetic of the surrounding page.
      container.innerHTML =
        '<div class="saif-compare">' +
          '<div class="saif-compare__heading">' +
            '<span class="saif-compare__eyebrow">Comparison</span>' +
            '<h3 class="saif-compare__title">Teacher &amp; Student, side by side</h3>' +
          '</div>' +
          '<div class="saif-compare__grid">' +
            '<div class="saif-compare__card saif-compare__card--teacher">' +
              '<span class="saif-compare__label">Teacher</span>' +
              '<canvas id="SaifAudioCompareTeacherWaveform" class="saif-compare__waveform"></canvas>' +
              '<audio id="SaifAudioCompareTeacher" class="saif-compare__audio" controls preload="metadata"' +
                (teacherSrc ? ' src="' + escapeHtml(teacherSrc) + '"' : '') + '></audio>' +
            '</div>' +
            '<div class="saif-compare__card saif-compare__card--student">' +
              '<span class="saif-compare__label">Student</span>' +
              '<canvas id="SaifAudioCompareStudentWaveform" class="saif-compare__waveform"></canvas>' +
              '<audio id="SaifAudioCompareStudent" class="saif-compare__audio" controls preload="metadata"' +
                (studentSrc ? ' src="' + escapeHtml(studentSrc) + '"' : '') + '></audio>' +
            '</div>' +
          '</div>' +
          '<div class="saif-compare__actions">' +
            '<button id="SaifAudioCompareBtn" type="button" class="saif-compare__btn">' +
              '<span class="saif-compare__btn-glyph" aria-hidden="true">◆</span>' +
              '<span class="saif-compare__btn-label">Play Both Together</span>' +
            '</button>' +
          '</div>' +
        '</div>';

      var teacherAudio = document.getElementById('SaifAudioCompareTeacher');
      var studentAudio = document.getElementById('SaifAudioCompareStudent');
      var compareBtn = document.getElementById('SaifAudioCompareBtn');

      // Compare button: sync playback
      compareBtn.addEventListener('click', function () {
        if (!teacherAudio.src && !studentAudio.src) return;

        // Reset both to start
        teacherAudio.currentTime = 0;
        studentAudio.currentTime = 0;

        // Play both simultaneously
        var p1 = teacherAudio.play().catch(function () { /* blocked */ });
        var p2 = studentAudio.play().catch(function () { /* blocked */ });

        // Update only the inner label so the glyph stays. Disable until
        // both tracks finish (or the user reloads the page).
        var labelEl = compareBtn.querySelector('.saif-compare__btn-label');
        if (labelEl) labelEl.textContent = 'Playing…';
        compareBtn.disabled = true;
        compareBtn.classList.add('saif-compare__btn--playing');

        // Re-enable when both finish
        var ended = 0;
        function onEnd() {
          ended++;
          if (ended >= 2) {
            if (labelEl) labelEl.textContent = 'Play Both Together';
            compareBtn.disabled = false;
            compareBtn.classList.remove('saif-compare__btn--playing');
          }
        }
        teacherAudio.addEventListener('ended', onEnd, { once: true });
        studentAudio.addEventListener('ended', onEnd, { once: true });
      });

      // Draw waveforms when audio loads
      if (teacherSrc) {
        this._drawWaveform(teacherSrc, document.getElementById('SaifAudioCompareTeacherWaveform'), '#B8860B');
      }
      if (studentSrc) {
        this._drawWaveform(studentSrc, document.getElementById('SaifAudioCompareStudentWaveform'), '#2D6A5A');
      }
    },

    _drawWaveform: function (src, canvas, color) {
      if (!canvas || !src) return;

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      ctx.scale(dpr, dpr);

      var W = rect.width;
      var H = rect.height;

      // Fetch and decode audio
      var audioCtx = new (window.AudioContext || window.webkitAudioContext)();

      fetch(src)
        .then(function (r) { return r.arrayBuffer(); })
        .then(function (buf) { return audioCtx.decodeAudioData(buf); })
        .then(function (audioBuffer) {
          var data = audioBuffer.getChannelData(0);
          var step = Math.ceil(data.length / W);

          ctx.clearRect(0, 0, W, H);
          ctx.fillStyle = color;

          for (var i = 0; i < W; i++) {
            var min = 1, max = -1;
            for (var j = 0; j < step; j++) {
              var datum = data[i * step + j] || 0;
              if (datum < min) min = datum;
              if (datum > max) max = datum;
            }
            var yLow = ((1 + min) / 2) * H;
            var yHigh = ((1 + max) / 2) * H;
            ctx.fillRect(i, yHigh, 1, Math.max(1, yLow - yHigh));
          }

          audioCtx.close();
        })
        .catch(function () {
          audioCtx.close();
        });
    }
  };

  /* ============================================
     17. BUNDLE DETECTION
     ============================================ */
  var SaifBundle = {
    init: function () {
      var config = readJSON('SaifBundleConfig');
      if (!config) return;

      var customer = getCustomer();
      if (!customer || !customer.loggedIn) return;

      // Check which courses the customer owns
      var purchases = readJSON('SaifCoursePurchases');
      if (!purchases) return;

      var allCourses = config.allCourses || [];
      var bundleVariantId = config.bundleVariantId;
      var bundlePrice = config.bundlePrice || 0;
      var individualTotal = config.individualTotal || 0;

      if (!allCourses.length || !bundleVariantId) return;

      // Check if customer already owns all courses
      var ownedCount = 0;
      allCourses.forEach(function (c) {
        if (purchases.indexOf(c.handle) !== -1) ownedCount++;
      });

      // Don't show if they own all courses or none
      if (ownedCount === 0 || ownedCount >= allCourses.length) return;

      var savings = individualTotal - bundlePrice;
      if (savings <= 0) return;

      // Show bundle banner
      var banner = document.createElement('div');
      banner.className = 'saif-bundle-banner';
      banner.style.cssText = 'background:linear-gradient(135deg, #2D6A5A 0%, #3D8B77 100%);color:#FAF7F2;' +
        'border-radius:12px;padding:20px 24px;margin-bottom:24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;';
      banner.innerHTML =
        '<div>' +
          '<div style="font-weight:700;font-size:16px;margin-bottom:4px;">Bundle & Save!</div>' +
          '<div style="font-size:14px;opacity:0.9;">Get all ' + allCourses.length + ' courses and save ' +
            (config.currencySymbol || '$') + savings.toFixed(2) + '</div>' +
        '</div>' +
        '<button id="SaifBundleBuy" type="button" ' +
          'style="padding:12px 24px;background:#8A6508;color:#FAF7F2;border:none;border-radius:8px;cursor:pointer;' +
          'font-size:14px;font-weight:700;white-space:nowrap;">Buy All Courses — ' +
          (config.currencySymbol || '$') + bundlePrice.toFixed(2) + '</button>';

      var courseDetail = document.querySelector('.saif-course__hero') ||
        document.querySelector('[data-course-handle]');
      if (courseDetail) {
        courseDetail.parentNode.insertBefore(banner, courseDetail);
      }

      // Add to cart
      document.getElementById('SaifBundleBuy').addEventListener('click', function () {
        var btn = document.getElementById('SaifBundleBuy');
        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(bundleVariantId),
              quantity: 1
            }]
          })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('Could not add to cart.');
          return r.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Try Again';
        });
      });
    }
  };

  /* ============================================
     INITIALIZATION
     ============================================ */
  document.addEventListener('DOMContentLoaded', function () {
    // Init features based on page context
    if (document.getElementById('SaifSocialProofConfig')) SaifSocialProof.init();
    if (document.getElementById('SaifBadgesGrid')) SaifBadges.init();
    if (document.getElementById('SaifSubmissionsList')) SaifSubmissions.init();
    if (document.getElementById('SaifAnalyticsDashboard')) SaifAnalytics.init();
    if (document.getElementById('SaifLessonExercises')) SaifExercises.init();
    if (document.getElementById('SaifLessonDiscussion')) SaifDiscussion.init();
    if (document.getElementById('SaifLessonTranscript')) SaifTranscript.init();
    if (document.getElementById('SaifLearningPath')) SaifLearningPath.init();
    if (document.getElementById('SaifReviewPrompts')) SaifReview.init();
    if (document.querySelector('.saif-gift__btn')) SaifGift.init();
    if (document.getElementById('SaifUpsellConfig')) SaifUpsell.init();
    if (document.getElementById('SaifReferralConfig')) SaifReferral.init();
    if (document.querySelector('[data-saif-countdown-standalone]')) SaifCountdownStandalone.init();
    if (document.getElementById('SaifLessonCompare')) SaifAudioCompare.init();
    if (document.getElementById('SaifBundleConfig')) SaifBundle.init();
    SaifSync.init();
  });
})();
